// Document ready
$(() => {
  // Open Mini Cart
  var openMiniCart = function () {
    window.mobileMenuDrawer.close();
    $('.dropdown_link').removeClass('active_link');
    $('.cart-container').addClass('active_link');
    $('.cart-drawer-overlay').addClass('active_link');
    $('.tos_warning.cart_content').removeClass('fadeOutr');
    $('.tos_warning.cart_content').addClass('fadeInd');
    jQuery('body').addClass('blocked-scroll');
    Cartslider();
  };

    window.utils.enableDisclosure();
    const oldFlickityCreate = window.Flickity.prototype._create;

    window.Flickity.prototype._create = function () {
        const that = this;
        if (this.element.addEventListener) {
            this.element.addEventListener(
                "load",
                () => {
                    that.onresize();
                },
                true
            );
        }
        this._create = oldFlickityCreate;
        return oldFlickityCreate.apply(this, arguments);
    };

    // Support for background images with new Lazysizes library
    document.addEventListener("lazyloaded", (e) => {
        let bg = e.target.getAttribute("data-bg");
        const mobileBg = e.target.getAttribute("data-mobile-bg");
        if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
                bg = mobileBg;
            }
            e.target.style.backgroundImage = `url(${bg})`;
        }
    });

    // Call to flickity fix for sliders on IOS
    window.imageFunctions.flickityIosFix();

    window.objectFitImages();
    window.header.init();
    window.meganavManager.injectAll();
    if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.searchAutocomplete.init();
    }
    window.utils.initializeSectionWrapper();
    window.slideshow.init();
    window.testimonials.init();
    window.video.init();
    window.gallery.init();
    window.videoFeature.setupVideoPlayer();
    window.featuredPromotions.init();
    window.featuredCollection.init();
    window.logoList.init();
    window.collectionSidebarFilter.init();
    window.cart.init();
    window.map.init();
    window.shoppableImage.init();
    window.productPage.init();
    window.productPage.runOptionSelector();
    window.productPage.initializeQuantityBox();
    window.recentlyViewed.init();
    window.sidebarAccordions.init();

    if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
        window.currencyConverter.init();
    }

    // Challenge page scroll

    // Return the pathname of the current URL
    const { pathname } = location;

    // If the pathname starts with '/challenge', animate scroll
    if (pathname.startsWith("/challenge")) {
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            "slow"
        );
    }

    // Setup a timer
    let resizeTimeout;
    // Grab screen width before screen is resized
    const beforeResizeWidth = $(window).width();

    // Listen for resize events
    window.addEventListener(
        "resize",
        () => {
            // If timer is null, reset it to 66ms and run your functions.
            // Otherwise, wait until timer is cleared
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(() => {
                    // Reset timeout
                    resizeTimeout = null;
                    // Grab screen width after screen is resized
                    const currentScreenWidth = $(window).width();
                    // Run our resize functions
                    if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
                        window.cart.init();
                        if (!window.is_touch_device()) {
                            window.header.unload();
                            window.header.init();
                        }
                    }

                    window.logoList.init();

                    // swap lazysizes background mobile images when browser is resized
                    const lazysizesBackgroundImages = document.querySelectorAll("[data-bg]");
                    lazysizesBackgroundImages.forEach((image) => {
                        let bg = image.getAttribute("data-bg");
                        const mobileBg = image.getAttribute("data-mobile-bg");

                        if (bg) {
                            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
                                bg = mobileBg;
                            }

                            image.style.backgroundImage = `url(${bg})`;
                        }
                    });
                }, 66);
            }
        },
        false
    );

    // Lightbox default options
    // https://fancyapps.com/fancybox/3/docs/#options
    $.fancybox.defaults.animationEffect = "fade";
    $.fancybox.defaults.transitionEffect = "fade";
    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.infobar = false;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.arrows = false;
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.smallBtn = true;
    $.fancybox.defaults.live = false;
    $.fancybox.defaults.zoom = false;
    $.fancybox.defaults.mobile.preventCaptionOverlap = false;
    $.fancybox.defaults.mobile.toolbar = true;
    $.fancybox.defaults.mobile.buttons = ["close"];
    $.fancybox.defaults.mobile.clickSlide = "close";
    $.fancybox.defaults.mobile.clickContent = "zoom";
    $.fancybox.defaults.afterLoad = function (instance, slide) {
      console.log("sliddee",instance.current.type);
        if (instance.current.type === "image" || instance.current.type === 'inline' || instance.current.type === 'video') {
            slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
        }
        if (instance.group.length > 1) {
            slide.$content
                .find(".fancybox-image-wrap")
                .append(
                    `<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`
                );
        }
    };

    // backwards compatibility with custom lightboxes
    $('.lightbox[rel="gallery"]').fancybox();

    // Find youtube and vimeo iframes
    const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

    // For each iframe, if parent is a responsive video wrapper do nothing
    // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

    function getAspectRatio(width, height) {
        const ratio = width / height;

        // Determine ratio to be used
        if (Math.abs(ratio - 1 / 1) === 0) {
            return "1:1";
        }
        return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? "4:3" : "16:9";
    }

    $videoIframes.each((_index, iframe) => {
        // Update selector
        const $iframe = $(iframe);

        // Grab src
        const source = $iframe.attr("src");

        if (!$iframe.parents(".plyr__video-wrapper").length && !$iframe.parents(".lazyframe").length) {
            $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr("width"), $iframe.attr("height"))}" data-src="${source}"></div>`);
        }
    });

    // Initiate lazyframe
    window.lazyframe(".lazyframe");

    // Wrap shopify policy in grid layout classes
    $(".shopify-policy__container").wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

    // Add classes to determine column size
    $(".shopify-policy__container").addClass("five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole");

    // Add featured divider beneath page title
    $(".shopify-policy__title").append('<div class="feature-divider"></div>');

    // Search input hiding
    // get current input
    const currentValue = $(".search__form input[name='q']").val();
    // return amount without *
    if ($(".search__form input[name='q']").length > 0) {
        $(".search__form input[name='q']").val(currentValue.replace("*", ""));
    }

    // Collection sorting

    const sortByEl = document.querySelector("[data-sort-by]");

    if (sortByEl) {
        sortByEl.addEventListener("change", (e) => {
            const { target } = e;
            const sortValue = target.value;
            if (target) {
                // Set the query string and redirect
                const queryString = new URLSearchParams(document.location.search);
                queryString.set("sort_by", sortValue);
                window.location.search = queryString;
            }
        });
    }

    $("body").on("change", "#tag_filter", () => {
        $("[data-option-filter] input").prop("checked", false);
        window.quickFilter.init();
    });

    $("body").on("change", "#blog_filter", function () {
        const url = $(this).val();
        window.location = url;
    });

    $("input, select, textarea").on("focus blur", (event) => {
        $("meta[name=viewport]").attr("content", `width=device-width,initial-scale=1,maximum-scale=${event.type === "blur" ? 10 : 1}`);
    });

    // Collection sidebar filter
    // Check the checkbox values
    $("body").on("change", "[data-option-filter] input", () => {
        window.quickFilter.init();
        $("html, body").animate(
            {
                scrollTop: $(".content").offset().top,
            },
            500
        );
    });

    $("body").on("click", "[data-reset-filters]", () => {
        window.collectionSidebarFilter.clearAllFilters();
    });

    $("body").on("click", "[data-clear-filter]", (e) => {
        const $this = $(e.currentTarget);
        const selectedOption = $this.parents(".filter-active-tag");
        window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
    });

    $("body").on("change", ".currencies", () => {
        $("[data-initial-modal-price]").attr("data-initial-modal-price", "");
    });

    $("body").on("change", ".js-quick-shop select", () => {
        const currentVariant = $('.js-quick-shop select[name="id"]').val();
        if (currentVariant && window.globalQuickShopProduct) {
            window.quickShop.updateVariant(currentVariant);
        }
    });

    if (window.PXUTheme.theme_settings.quick_shop_enabled) {
        window.quickShop.init();
    }

    let touchStartPos = 0;

    // Detecting swipe vs tap
    $(document)
        .bind("touchstart", () => {
            touchStartPos = $(window).scrollTop();
        })
        .bind("touchend", (e) => {
            const distance = touchStartPos - $(window).scrollTop();
            if (distance > 20 || distance < -20) {
                e.preventDefault;
            }
        });

    $("body").on("click", ".sidebar .parent-link--false", function (e) {
        e.preventDefault();
        const $menu = $(this).parent("li");
        $menu.find(".menu-toggle").toggleClass("active");
        $menu.find("ul").slideToggle();
    });

    if (window.PXUTheme.theme_settings.newsletter_popup) {
        window.newsletter_popup.init();
    }

    if (window.location.pathname.indexOf("/comments") !== -1) {
        $("html,body").animate({ scrollTop: $("#new-comment").offset().top - 140 }, "slow");
    }

    $("body").on("mouseenter", ".icon-search", () => {
        $(".search-terms").focus();
    });

    $("body").on("click", ".icon-search", () => {
        $("input.search-terms").focus();
    });

    $("body").on("click", ".search-submit", (e) => {
        const $this = $(e.currentTarget);
        $this.parent().submit();
    });

    if (window.PXUTheme.media_queries.large.matches) {
        $(".animate_right").waypoint(
            function () {
                $(this.element).addClass("animated fadeInRight");
            },
            { offset: "70%" }
        );
        $(".animate_left").waypoint(
            function () {
                $(this.element).addClass("animated fadeInLeft");
            },
            { offset: "70%" }
        );
        $(".animate_up").waypoint(
            function () {
                $(this.element).addClass("animated fadeInUp");
            },
            { offset: "70%" }
        );
        $(".animate_down").waypoint(
            function () {
                $(this.element).addClass("animated fadeInDown");
            },
            { offset: "70%" }
        );
    }

    // backwards compatibility with flexslider
    $(".slider, .flexslider").find("li").unwrap();
    $(".slider, .flexslider").flickity({
        pageDots: window.usePageDots,
        imagesLoaded: true,
        arrowShape: window.arrowSize,
        lazyLoad: 2,
    });

    window.utils.createAccordion(".footer_menu", "h6", "ul");
    window.utils.createAccordion(".footer_content", "h6", "div.toggle_content");
    window.utils.createAccordion(".product_section .accordion-tabs", ".tabs li > a", ".tabs-content li");
    window.utils.mobileParentActiveAccordion("#mobile_menu", "li.sublink > a.parent-link--true span", "li.sublink ul");
    window.utils.mobileAccordion("#mobile_menu", "li.sublink > a.parent-link--false", "li.sublink ul");

    window.utils.initializeTabs();
    window.accordion.init();

    $("body").on("click", ".menu-toggle", function () {
        const $content = $(this).next("ul");
        $content.slideToggle();
        $(this).toggleClass("active");
        $(this).attr("aria-expanded", $(this).attr("aria-expanded") === "true" ? "false" : "true");
    });

    if (window.PXUTheme.theme_settings.collection_swatches) {
        if (window.PXUTheme.media_queries.large.matches) {
            $("body").on("mouseenter", ".collection_swatches", function () {
                $(".swatch span", $(this)).each(function () {
                    if ($(this).data("image").indexOf("no-image") === -1) {
                        $('<img alt=""/>')[0].src = $(this).data("image");
                    }
                });
            });
            $("body").on("mouseenter", ".swatch span", function () {
                if ($(this).data("image").indexOf("no-image") === -1) {
                    $(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("src", $(this).data("image"));
                    $(this).parents(".thumbnail").find(".image__container img:not(.secondary)").attr("srcset", $(this).data("image"));
                }
            });
        }
    }

    // Terms of service settings for minicart
    if (window.PXUTheme.theme_settings.display_tos_checkbox) {
        $("body").on("click touchstart", ".cart_content .tos_label", function () {
            $(this).prev("input").prop("checked", true);
        });
    }

    if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
        // Terms of service on mini-cart && cart page
        $("body").on("click", ".tos_warning [data-cart-checkout-button]", function (e) {
            if ($(this).parents("form").find(".tos_agree").is(":checked")) {
                // Check if we are on the cart page or mini cart
                if (window.PXUTheme.theme_settings.go_to_checkout || $("body").hasClass("cart")) {
                    $(this).submit();
                } else {
                    // Redirect to cart page
                    e.preventDefault();
                    document.location.href = window.PXUTheme.routes.cart_url;
                }
            } else {
                const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
                if ($("p.warning").length === 0) {
                    $(this).before(warning);
                }
                return false;
            }
        });
    } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
        $("body").on("click", ".cart_content [data-minicart-checkout-button]", (e) => {
            // Redirect to cart page
            e.preventDefault();
            document.location.href = window.PXUTheme.routes.cart_url;
        });
    }

    if (window.PXUTheme.theme_settings.collection_secondary_image) {
        window.imageFunctions.showSecondaryImage();
    }

    // Contact form checkbox validation
    if ($("[data-is-required]").length) {
        const $checkboxGroup = $(".custom-contact__checkbox");
        $checkboxGroup.prop("required", true);

        $checkboxGroup.on("change", () => {
            $checkboxGroup.prop("required", true);
            if ($checkboxGroup.is(":checked")) {
                $checkboxGroup.prop("required", false);
            }
        });
    }

    $(".maps").click(() => {
        $(".maps iframe").css("pointer-events", "auto");
    });

    // Load more / infinite load

    if (window.PXUTheme.theme_settings.pagination_type === "load_more") {
        window.enableLoadMoreProducts();
    }

    if (window.PXUTheme.theme_settings.pagination_type === "load_more_button") {
        window.enableLoadMoreButton(".product-list");
    }

    if (window.PXUTheme.theme_settings.pagination_type === "infinite_scroll") {
        window.enableInfiniteScroll(".product-list");
    }

    /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

    function ajaxSubmitCart(cart) {
        const $cart = cart;
        $.ajax({
            url: "/cart/update.js",
            dataType: "json",
            cache: false,
            type: "post",
            data: $cart.serialize(),
            success(data) {
                refreshCart(data);
            },
        });
    }

    function updateCartItemQuantity(cartItem, currentLine) {
      if(cartItem.itemType == 'bundle'){
        var linkItemId =  cartItem.lineID;
        var linkIdArr = linkItemId.split("___");
        var updateData = {};
        for(var i=0; i < linkIdArr.length; i++){
          if(linkIdArr[i] != ''){
            updateData[linkIdArr[i]] = cartItem.quantity;
          }
        }

        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: {
           updates: updateData
         },
         dataType: 'json',
         success: function(cart){
           refreshCart(cart);
         },
         error: function(err){ console.error('Booo!', err) }
        });
      }
      else{
        $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: {
            quantity: cartItem.quantity,
            line: cartItem.lineID,
          },
          success(data) {
            const cartItemsArray = data.items;
            const lineIDIndex = cartItem.lineID - 1;
            const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
            const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
            let initialQuantityTotal = 0;
            let apiQuantityTotal = 0;
            const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

            // Check if item has a "Buy X get Y" deal
            if ($quantityInputs.length > 1) {
              // Multiple inputs

              // Get all the quantities of same variants in the cart (including BOGO) in HTML
              $.each($quantityInputs, (_i, input) => {
                initialQuantityTotal += parseInt($(input).val());
              });

              // Get quantities from cart object returned from API
              cartItemsArray.forEach(item => {
                if (item.variant_id === cartItem.variantID) {
                  apiQuantityTotal += item.quantity;
                }
              });
            }
            else {
              // Single input
              initialQuantityTotal = parseInt($quantityInputs.val());
              apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
            }

            // Checks to see if there is enough inventory to update to an increased amount
            if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
              if (apiQuantityTotal === 1) {
                itemsLeftText = window.PXUTheme.translation.one_item_left;
              } else {
                itemsLeftText = window.PXUTheme.translation.items_left_text;
              }

              $('.warning--quantity').remove();

              // Check if Buy one get one product
              if (totalCartItems < cartItemsArray.length) {
                if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
                  // Refreshes cart if inventory is available
                  cartItem.parentCartForm.submit();
                } else {
                  refreshCart(data);
                }
              } else {
                const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
                cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
                cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
              }
            }
            else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            }
            else {
              refreshCart(data);
            }
          },
          error: function (jqXHR, exception) {
            alert(jqXHR.responseJSON.message);
            currentLine.val(eval(cartItem.quantity) - 1);
            jQuery('.custom-loading').hide();
          }
        });
      }
    }

    function refreshCartID() {
        const cartItem = document.querySelectorAll(".cart__item");

        for (let i = 0; i < cartItem.length; i++) {
            const lineIndex = i + 1;
            const dataLineId = cartItem[i].querySelectorAll("[data-line-id]");

            for (let c = 0; c < dataLineId.length; c++) {
                dataLineId[c].dataset.lineId = lineIndex;
            }
        }
    }

    refreshCart = function refreshCart(cart) {
      let tryNowSubtotal = 0;
      cart.items.forEach(item => {
        if(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.includes('Try')){
          tryNowSubtotal = tryNowSubtotal + item.final_line_price;
        }
      })
      $('.cart_count').empty();
      const $cartBtn = $('.cart_count');
      const value = $cartBtn.text() || '0';
      let cartItemsHTML = '';
      let cartDiscountsHTML = '';
      let cartActionHTML = '';
      let cartSavingsHTML = '';
      const $cartForm = $('[data-cart-form]');
      let productHasSale = false;
      let productCompareAtPrice = 0;
      let productFinalPrice = 0;
      let cartTotal=0;
      $cartForm.data('total-discount', cart.total_discount);

      $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

      if (cart.item_count === 0) {

        $('.js-empty-cart__message').removeClass('hidden');
        $cartForm.addClass('hidden');
      } else {
        $('.js-empty-cart__message').addClass('hidden');
        $cartForm.removeClass('hidden');
        cartTotal = parseFloat(cart.total_price) / 100;
        let totalSaving = 0; // adding counter variables for total cart savings
        let saving = 0;
        let cpids = [];
        let totalComparePrice = 0;

        let bundpeProductCounter = 0;

        let dynamicArray = {};
        $.each(cart.items, (index, item) => {
          const itemDiscounts = item.discounts;

          let bundlePro = '';
          let bundleSizeVal = '';

          if(item.properties === null){
          }
          else{
            bundlePro = item.properties._bundleSize;
            bundleSizeVal = item.properties._bundleSizeVal;
            if (typeof bundlePro === "undefined") {
              bundlePro = '';
            }
          }

          // let bundlePro = item.properties._bundleSize;
          // if (typeof bundlePro === "undefined") {
          //   bundlePro = '';
          // }
          if(bundlePro == ''){
            let discountMessage = '';

            for (let i = 0; i < itemDiscounts.length; i++) {
              const { title } = itemDiscounts[i];
              var str2 = '40.75 off';
              if(title.indexOf(str2) != -1){
                discountMessage = `<p class="notification-discount meta">4SHIRTSFOR189</p>`;
              }
              else if(title.indexOf('42.75') != -1){
                discountMessage = `<p class="notification-discount meta">4SHIRTSFOR189</p>`;
              }
              else if(title.indexOf('47.75') != -1){
                discountMessage = `<p class="notification-discount meta">4SHIRTSFOR189</p>`;
              }
              else if(title.indexOf('28.75') != -1){
                discountMessage = `<p class="notification-discount meta">4SHIRTSFOR189</p>`;
              }
              else{
                discountMessage = `<p class="notification-discount meta">${title}</p>`;
              }
            }
            const lineID = index + 1;

            // custom cart darawer
            cpids.push(item.product_id);

            cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-pid="${item.product_id}" data-variant-id="${item.id}">`
              + `<a href="${item.url}">`;
            if (item.image) {
              cartItemsHTML += `${'<div class="cart_image">'
                  + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
                + '</div>';
            }
            cartItemsHTML += `</a>`;

            cartItemsHTML += `<div class="mini-cart__item--content okatdhfs"> <div class="mini-cart__item__title">
            <div class = "item_title" style="margin-top: 30px;">
              <a class="cutsentanceall" id="cutsentanceallall" href="${item.url}">${item.product_title}
              </a>
               <p class="cutsentancelatterin">${item.variant_title}</p>
            </div>`;

            if (item.selling_plan_allocation) {
              cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            cartItemsHTML += `<div id="spineinclude" class="spin_${lineID}" style="display:none"><i class="fa fa-circle-o-notch fa-spin cart-loading-spinner"></i></div>`;

            cartItemsHTML += '</div><div class="right-section">';

            $.ajax({
              dataType: 'json',
              async: false,
              cache: false,
              url: `/products/${item.handle}.js`,
              success(data) {
                if ($.inArray('bundle_discount', data.tags) != -1){
                  bundpeProductCounter = eval(bundpeProductCounter) + eval(item.quantity);
                }
                let productData = data;
                // If item has more than one variant, need to make sure we are pulling data from the correct variant
                if (productData.variants) {
                  const itemVariants = productData.variants;
                  if (itemVariants.length > 1) {
                    for (let v = 0; v < itemVariants.length; v++) {
                      if (itemVariants[v].id === item.id) {
                        productData = itemVariants[v];
                      }
                    }
                  }
                }

                // If compare at price exists then item is on sale
                if (productData.compare_at_price && productData.compare_at_price > productData.price) {
                  productHasSale = true;
                  productCompareAtPrice = productData.compare_at_price;
                  productFinalPrice = productData.price;
                } else {
                  // Check required for non-sale items
                  productHasSale = false;
                }
              },
            });

            if(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.includes('Try')){
              totalComparePrice = eval(totalComparePrice) + eval(item.price * item.quantity);
              cartItemsHTML += `<span class="left price money sale">$0.00</span>`;
            } else {
              if (productHasSale === true) {
                totalComparePrice = eval(totalComparePrice) + eval(productCompareAtPrice * item.quantity);
                // puts the slash through the old item price

                // cartItemsHTML += `<div class = "price-with-compare">`;
                // const itemPrice = `${window.Shopify.formatMoney(productFinalPrice * item.quantity, $('body').data('money-format'))} </span><span class=" money was_price">${window.Shopify.formatMoney(productCompareAtPrice * item.quantity, $('body').data('money-format'))}</span>`;
                // cartItemsHTML += `<span class="left price money sale">${itemPrice}</span> </div>`;


                // new change here
                cartItemsHTML += `<div class = "price-with-compare">`;
                const discountedPrice = item.final_line_price;
                if (item.final_line_price) {
                  const itemPrice = `${window.Shopify.formatMoney(discountedPrice, $('body').data('money-format'))} </span><span class=" money was_price">${window.Shopify.formatMoney(productCompareAtPrice * item.quantity, $('body').data('money-format'))}</span>`;
                  cartItemsHTML += `<span class="left price money sale">${itemPrice}</span> </div>`;
                } else {
                  const itemPrice = `${window.Shopify.formatMoney(productFinalPrice * item.quantity, $('body').data('money-format'))} </span><span class=" money was_price">${window.Shopify.formatMoney(productCompareAtPrice * item.quantity, $('body').data('money-format'))}</span>`;
                  cartItemsHTML += `<span class="left price money sale">${itemPrice}</span> </div>`;
                }
                console.log("discountprice", discountedPrice);

                // Total savings
                saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
                totalSaving = saving + totalSaving;
              }
              else if (item.price > item.final_price) {
                totalComparePrice = eval(totalComparePrice) + eval(item.original_price * item.quantity);
                // puts the slash through the old item price
                cartItemsHTML += `<div class="price--discount">`;
                const itemPrice = `${window.Shopify.formatMoney(item.final_price * item.quantity, $('body').data('money-format'))} </span><span class="left price money was_price">${window.Shopify.formatMoney(item.price * item.quantity, $('body').data('money-format'))}</span>`;
                cartItemsHTML += `<span class="left price money sale">${itemPrice}</span>`;
                cartItemsHTML += `</div>`;
              }
              else {
                totalComparePrice = eval(totalComparePrice) + eval(item.price * item.quantity);
                const itemPrice = window.Shopify.formatMoney(item.price * item.quantity, $('body').data('money-format'));
                if (item.price > 0) {
                  cartItemsHTML += `<span class="left price money sale">${itemPrice}</span>`;
                } else {
                  cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text} </span>`;
                }
              }
            }

            // Unit price

            if (item.unit_price_measurement && item.price > 0) {
              let unitPriceMeasurementReferenceValue = '';

              if (item.unit_price_measurement.reference_value !== 1) {
                unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
              }

              cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
            }

            if (item.price > item.final_price) {
              cartItemsHTML += discountMessage;
            }

            cartItemsHTML += '<div class="left product-quantity-box">';

            cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn pid-${item.id} productid-${item.product_id}" data-line-id="${lineID}" data-ctpid="${item.product_id}" data-remove-item="mini-cart">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path d="M11.1667 4.00004V3.46671C11.1667 2.71997 11.1667 2.3466 11.0213 2.06139C10.8935 1.8105 10.6895 1.60653 10.4387 1.4787C10.1534 1.33337 9.78007 1.33337 9.03333 1.33337H7.96667C7.21993 1.33337 6.84656 1.33337 6.56135 1.4787C6.31046 1.60653 6.10649 1.8105 5.97866 2.06139C5.83333 2.3466 5.83333 2.71997 5.83333 3.46671V4.00004M7.16667 7.66671V11M9.83333 7.66671V11M2.5 4.00004H14.5M13.1667 4.00004V11.4667C13.1667 12.5868 13.1667 13.1469 12.9487 13.5747C12.7569 13.951 12.451 14.257 12.0746 14.4487C11.6468 14.6667 11.0868 14.6667 9.96667 14.6667H7.03333C5.91323 14.6667 5.35318 14.6667 4.92535 14.4487C4.54903 14.257 4.24307 13.951 4.05132 13.5747C3.83333 13.1469 3.83333 12.5868 3.83333 11.4667V4.00004" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              </a>`;
            cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M3.625 7.5H12.375" stroke="#454545" stroke-width="1.25" stroke-linecap="square"></path></svg></span></span>';
            cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
            cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M8 3.125V11.875M3.625 7.5H12.375" stroke="#454545" stroke-width="1.25" stroke-linecap="square"></path></svg></span></span>';

            cartItemsHTML += '</div></div></div>';
            cartItemsHTML += '</div>';
            cartItemsHTML += '</li>';
          }
          else{
            if (!dynamicArray[bundlePro]) {
              dynamicArray[bundlePro] = {};
            }
            if (!dynamicArray[bundlePro][bundleSizeVal]) {
              dynamicArray[bundlePro][bundleSizeVal] = [];
            }

            dynamicArray[bundlePro][bundleSizeVal].push(item);
          }
        });

        /*$('.shipping___bundle_bar').show();
        if(bundpeProductCounter > 0){

          if(bundpeProductCounter < 3){
            var pendingPro = 3 - bundpeProductCounter;
            var pendingPre = '33%';
          }
          if(bundpeProductCounter >= 3 && bundpeProductCounter < 5){
            var pendingPro = 5 - bundpeProductCounter;
            var pendingPre = '45%';
          }
          if(bundpeProductCounter >= 5 && bundpeProductCounter < 9){
            var pendingPro = 9 - bundpeProductCounter;
            var pendingPre = '50%';
          }
          var perProIncr = 100 / 9;
          var progress = bundpeProductCounter * perProIncr;
          if(progress > 100){
            progress = 100;
          }
          if(bundpeProductCounter >= 9){
            $('.saveoff').hide();
            $('.saveoff-full').show();
          }
          $('.bb_progress_filled').css('width', progress+'%');
          $('.progress-count').text(pendingPro);
          $('.percent-text').text(pendingPre);
        }*/
        let bundleCounter = 0;

        //console.log("cartItemsHTML===>", cartItemsHTML)
        //console.log("dynamicArray-->", dynamicArray)
        $.each(dynamicArray, (key, innerMainArray) => {
          $.each(innerMainArray, (key2, innerArray) => {

            var itemQty = 0;
            var itemLineKey = '';
            var itemParentHandle = '';
            var itemParentTitle = '';
            var itemParentImage = '';
            var itemDivideCounter = '';
            var itemBundleQty = '';
            var bundleSizeVal = '';
            $.each(innerArray, function(index, item) {
              itemQty = itemQty + item.quantity;
              if(itemLineKey != ''){
                itemLineKey += '___';
              }
              itemLineKey += item.key;
              itemParentHandle = item.properties._productHandle;
              itemParentTitle = item.properties._productTitle;
              itemParentImage = item.properties._productImage;
              itemDivideCounter = item.properties._bundlepCount;
              itemBundleQty = item.properties._bundleQty;
              bundleSizeVal = item.properties._bundleSizeVal;
            });
            var newItemQty = itemQty / itemDivideCounter;
            bundleCounter = eval(bundleCounter) + 1;
            cartItemsHTML += `<li class="${itemParentHandle} mini-cart__item" data-cart-item data-line-id="${itemLineKey}" data-variant-id="" data-item-type="bundle">`;
            cartItemsHTML += `<a href="${itemParentHandle}">`;
            cartItemsHTML += `<div class="cart_image">`;
            cartItemsHTML += `<img src="${itemParentImage}" alt="${itemParentTitle}" />`;
            cartItemsHTML += `</div>`;
            cartItemsHTML += `</a>`;

            cartItemsHTML += `<div class="mini-cart__item--content okatdhfs"> <div class="mini-cart__item__title">
              <div class = "item_title" style="margin-top: 30px;">
                <a class="cutsentanceall" id="cutsentanceallall" href="/products/trouser-bundle">${itemParentTitle}
                </a>
                 <p class="cutsentancelatterin">${bundleSizeVal}</p>
              </div>`;
            cartItemsHTML += `<div id="spineinclude" class="spin_${bundleCounter}" style="display:none"><i class="fa fa-circle-o-notch fa-spin cart-loading-spinner"></i></div>`;

            cartItemsHTML += '</div><div class="right-section">';

            $.ajax({
                dataType: 'json',
                async: false,
                cache: false,
                url: '/products/'+itemParentHandle+'.js',
                success(data) {
                  let productData = data;
                  // If item has more than one variant, need to make sure we are pulling data from the correct variant
                  if (productData.variants) {
                    const itemVariants = productData.variants;
                    if (itemVariants.length > 1) {
                      for (let v = 0; v < itemVariants.length; v++) {
                        if (itemVariants[v].id === item.id) {
                          productData = itemVariants[v];
                        }
                      }
                    }
                  }

                  // If compare at price exists then item is on sale
                  if (productData.compare_at_price) {
                    if (productData.compare_at_price > productData.price) {
                      productHasSale = true;
                      productCompareAtPrice = productData.compare_at_price;
                      productFinalPrice = productData.price;
                    } else {
                      // Check required for non-sale items
                      productHasSale = false;
                    }
                  } else {
                    // Check required for non-sale items
                    productHasSale = false;
                  }
                },
              });

            if (productHasSale === true) {
              // puts the slash through the old item price
              cartItemsHTML += `<div class = "price-with-compare">`;
              const itemPrice = `${window.Shopify.formatMoney(productFinalPrice * newItemQty, $('body').data('money-format'))} </span><span class=" money was_price">${window.Shopify.formatMoney(productCompareAtPrice * newItemQty, $('body').data('money-format'))}</span>`;
              cartItemsHTML += `<span class="left price money sale">${itemPrice}</span> </div>`;

              // Total savings
              saving = (productCompareAtPrice - productFinalPrice) * newItemQty
              totalSaving = saving + totalSaving;
            }
            else if (item.price > item.final_price) {
              // puts the slash through the old item price
              cartItemsHTML += `<div class="price--discount">`;
              const itemPrice = `${window.Shopify.formatMoney(item.final_price * newItemQty, $('body').data('money-format'))} </span><span class="left price money was_price">${window.Shopify.formatMoney(item.price * newItemQty, $('body').data('money-format'))}</span>`;
              cartItemsHTML += `<span class="left price money sale">${itemPrice}</span>`;
              cartItemsHTML += `</div>`;
            }
            else {
              const itemPrice = window.Shopify.formatMoney(item.price * newItemQty, $('body').data('money-format'));
              if (item.price > 0) {
                cartItemsHTML += `<span class="left price money sale">${itemPrice}</span>`;
              } else {
                cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text} </span>`;
              }
            }

            cartItemsHTML += '<div class="left product-quantity-box">';

            cartItemsHTML += `<a href="/cart/change?line=${bundleCounter}&amp;quantity=0" class="js-cart-remove-btn pid-${bundleCounter} productid-buundle" data-line-id="" data-remove-item="mini-cart">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                      <path d="M11.1667 4.00004V3.46671C11.1667 2.71997 11.1667 2.3466 11.0213 2.06139C10.8935 1.8105 10.6895 1.60653 10.4387 1.4787C10.1534 1.33337 9.78007 1.33337 9.03333 1.33337H7.96667C7.21993 1.33337 6.84656 1.33337 6.56135 1.4787C6.31046 1.60653 6.10649 1.8105 5.97866 2.06139C5.83333 2.3466 5.83333 2.71997 5.83333 3.46671V4.00004M7.16667 7.66671V11M9.83333 7.66671V11M2.5 4.00004H14.5M13.1667 4.00004V11.4667C13.1667 12.5868 13.1667 13.1469 12.9487 13.5747C12.7569 13.951 12.451 14.257 12.0746 14.4487C11.6468 14.6667 11.0868 14.6667 9.96667 14.6667H7.03333C5.91323 14.6667 5.35318 14.6667 4.92535 14.4487C4.54903 14.257 4.24307 13.951 4.05132 13.5747C3.83333 13.1469 3.83333 12.5868 3.83333 11.4667V4.00004" stroke="#454545" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
              </a>`;
            cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M3.625 7.5H12.375" stroke="#454545" stroke-width="1.25" stroke-linecap="square"></path></svg></span></span>';
            //cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${bundleCounter}" value="${newItemQty}" data-cart-quantity-input="mini-cart" />`;
            cartItemsHTML += `<input type="number" min="0" class="quantity" value="${newItemQty}" />`;
            cartItemsHTML += `<input style="display:none;" type="number" min="0" class="quantity" name="updates[]" id="updates_${bundleCounter}" value="${itemQty}" data-cart-quantity-input="mini-cart" data-itemDivideCounter="${itemDivideCounter}" data-itembundleqty="${itemBundleQty}" />`;
            cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path d="M8 3.125V11.875M3.625 7.5H12.375" stroke="#454545" stroke-width="1.25" stroke-linecap="square"></path></svg></span></span>';

            cartItemsHTML += '</div></div></div>';
            cartItemsHTML += '</div>';
          });
        });

        // custom cart drawer
        $('.removable-product').each(function () {
          let pid = $(this).data("pid");
          $("[data-coffer='" + pid + "']").removeClass('active');
          if (cpids.includes(pid)) {
            $("[data-pid='" + pid + "']").hide();
            $("[data-coffer='" + pid + "']").addClass('active');
          }
          else {
            $("[data-pid='" + pid + "']").show();
          }
        });

        $('.item-slick-upsell').each(function () {
          let pid = $(this).data("pid");
          //console.log("PID " + pid);
          let curindex = $(this).attr('data-slick-index');
          if (cpids.includes(pid)) {
            //console.log("Remove index: " + curindex);
            $('.' + pid + '-slick-removable').hide();
            //$('.cart-product-slider').slick('slickRemove',curindex);
          } else {
            $('.' + pid + '-slick-removable').show();
          }
        })

        // custom cart drawer
        const cartDiscounts = cart.cart_level_discount_applications;

        for (let i = 0; i < cartDiscounts.length; i++) {
          const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
          const { title } = cartDiscounts[i];

          cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
          cartDiscountsHTML += '<span class="cart_discounts--price">';
          cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
        }

        cartActionHTML += `<span class="right">`;
        if(totalComparePrice != 0){
          if(totalComparePrice != cart.total_price){
            cartActionHTML += `<span class="money compare-subtotal">${window.Shopify.formatMoney(totalComparePrice, $('body').data('money-format'))}</span>`;
          }
        }

        if(tryNowSubtotal > 0){
          cartActionHTML += `<span class="money main-subtotal">${window.Shopify.formatMoney((cart.total_price - tryNowSubtotal), $('body').data('money-format'))}</span></span> <span>Amount Due Today</span>`;
        }else{
          cartActionHTML += `<span class="money main-subtotal">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
        }

        totalSaving += cart.total_discount;
        if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
          cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
              + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
        } else {
          cartSavingsHTML = '';
        }

        var shippingFreeThreshold = '175';
        console.log("shippingFreeThreshold-->", shippingFreeThreshold)
        console.log("cart_total-->", cart.total_price)
        var freeShippingPercentage = ( (parseInt(cart.total_price)/100) / parseInt(shippingFreeThreshold)) * 100;
        var leftForFreeShipping = parseInt((shippingFreeThreshold * 100) - parseFloat(cart.total_price));
        console.log("leftForFreeShipping-->", leftForFreeShipping)
        var completeShippingStr = $('.Cart__ShippingNotice').attr('data-complete-shipping');
        var pendingShippingStr = $('.Cart__ShippingNotice').attr('data-pending-shipping');
        //console.log("freeShippingPercentage", freeShippingPercentage)
        if(freeShippingPercentage >= 100){
          //console.log("in");
          var newTempStr = completeShippingStr.replace("Congrats!", "Congrats!").replace("FREE Shipping", "FREE Shipping!");
          $('.progress-free-shipping').find('span').html(newTempStr);
          var compeleteStr = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">';
              compeleteStr += '<path d="M6 13.6133L1.86 9.47333L3.74667 7.58666L6 9.84666L12.5867 3.25333L14.4733 5.13999L6 13.6133Z" fill="white"/>';
              compeleteStr += '</svg>';
          $('.material-icons-outlined').html(compeleteStr);
          $('.progress-barDevite').find('.progress-segment').css("width","100%");
          var freeShippingStr = '<li id="cart_shipping" class="cart_shipping " style="border:none; ">';
              freeShippingStr += '<span class="right" style="color: #d54d4d;font-weight: 600;"> FREE </span>';
              freeShippingStr += '<span>Shipping</span>';
              freeShippingStr += '</li>';
          $('.cart_shipping').remove();
          $('.cart_subtotal').after(freeShippingStr);
          $('.cart_shipping').show();

          var freeShippingStr1 = '<div class="shipping_inner" id="shipping_inner">';
              freeShippingStr1 += '<h5 class="shipping_title">Shipping</h5>';
              freeShippingStr1 += '<span class="shipping_label">Free</span>';
              freeShippingStr1 += '</div>';
          $('.shipping_inner').remove();
          $('.subtotal_inner').after(freeShippingStr1);
        }
        else{
          $('.shipping_inner').remove();
          $('.cart_shipping').remove();
          $('.progress-free-shipping').find('span').html(pendingShippingStr);
          //$('.progress-free-shipping').find('span.money').html(window.Shopify.formatMoney(leftForFreeShipping, $('body').data('money-format')));
          $('.progress-free-shipping').find('strong').find('b').html(window.Shopify.formatMoney(leftForFreeShipping, $('body').data('money-format')));
          $('.material-icons-outlined').html(Math.round(freeShippingPercentage)+'%');
          $('.progress-barDevite').find('.progress-segment').css("width",Math.round(freeShippingPercentage)+"%");
        }
      }

      //console.log(cartItemsHTML)
      $('.js-cart_items').html(cartItemsHTML);
      $('.js-cart_discounts').html(cartDiscountsHTML);
      $('.js-cart_subtotal').html(cartActionHTML);
      $('.js-cart_savings').html(cartSavingsHTML);

      // Converting the currencies
      if (window.PXUTheme.currency.show_multiple_currencies) {
        window.currencyConverter.convertCurrencies();
      }

      // if($(".cart-product-slider").lenfth > 0){
      //   $(".cart-product-slider").slick('unslick');
      //   $(".cart-product-slider").slick({
      //       slidesToShow: 2,
      //       slidesToScroll: 1,
      //       arrows: true,
      //       infinite: false,
      //       autoplay: false,
      //       centerMode: false
      //   });
      // }

      /*********************** CART DRAWER PROGRESS BAR NEW TOP START JS **********************/
      /*
      if(jQuery('.gwp_promo_product.cartrecom-product').attr('data-goals')!="" && jQuery('.gwp_promo_product.cartrecom-product').attr('data-goals')!=undefined){
        var goalGwpProduct = jQuery('.gwp_promo_product.cartrecom-product').attr('data-goals');
        var convertedThreshold = 0;
        if (typeof Shopify !== 'undefined' && Shopify.currency) {
          // Conversion rate from base currency to current currency
          var conversionRate = Shopify.currency.rate || 1;
          // Convert threshold to current currency
          convertedThreshold = goalGwpProduct * conversionRate;
        }
        //console.log("convertedThreshold",convertedThreshold);
        goalGwpProduct = convertedThreshold;
        var gwpProductPercentage = (cartTotal / goalGwpProduct) * 100;
        var leftFreeGwpProduct = (goalGwpProduct * 100) - parseFloat(cart.total_price);
        var gwpProductId = jQuery('.gwp_promo_product.cartrecom-product').attr('data-pid');
        if(jQuery('.progress_bar_').length>0){
          if(gwpProductPercentage >= 100) {
            jQuery('.progress_bar_').find('.progress_a_title').hide();
            jQuery('.progress_bar_').find('.progress_title').show();
            console.log("hiiiiiii",jQuery('.cart_items.js-cart_items').find('.mini-cart__item[data-pid="'+gwpProductId+'"]').length);
            if(jQuery('.cart_items.js-cart_items').find('.mini-cart__item[data-pid="'+gwpProductId+'"]').length>0){
              jQuery('.gwp_promo_product.cartrecom-product').hide();
            }else{
              jQuery('.gwp_promo_product.cartrecom-product').show();
            }
          }else{
            jQuery('.gwp_promo_product.cartrecom-product').hide();
            if(jQuery('.progress_bar_').find('.progress_a_title').length>0){
              jQuery('.progress_bar_').find('.progress_a_title').show();
              jQuery('.progress_bar_').find('.progress_title').hide();
              var amountFinal = window.Shopify.formatMoney(leftFreeGwpProduct, $('body').data('money-format'));
              amountFinal = amountFinal.replace(/,00$/, '');
              //console.log("amountFinal",amountFinal);
              jQuery('.progress_bar_').find('.progress_a_title').find('strong').text(amountFinal);
              jQuery('.progress_bar_').find('.progress-barDevite').find('.progress-segment').css("width", Math.round(gwpProductPercentage) + "%");
            }
            if(jQuery('.cart_items.js-cart_items').find('.mini-cart__item[data-pid="'+gwpProductId+'"]').length>0){
              var variantId = jQuery('.cart_items.js-cart_items').find('.mini-cart__item[data-pid="'+gwpProductId+'"]').attr('data-variant-id');
              removeGwpProduct(variantId);
            }
          }
        }
      }
      */
      /*
      function removeGwpProduct(variantId){
        if(variantId!="" && variantId!=undefined){
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
              quantity: 0,
              id: variantId
            },
            dataType: 'json',
            success: function(cart) {
              $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {

                    refreshCart(cart);
                    if ($('body').hasClass('fancybox-active')) {
                      $.fancybox.close();
                    }

                    openMiniCart();

                    if ($('#header').is(':visible')) {
                      $('#header .cart-container').addClass('active_link');
                    }
                    else if ($('.sticky_nav--stick').length) {
                      $('.sticky_nav .cart-container').addClass('active_link');
                    }
                    else {
                      $('.top-bar .cart-container').addClass('active_link');
                    }


                    // block scrolling on mobile
                    if (window.PXUTheme.media_queries.medium.matches) {
                      const $cartContainer = $(this).parent();
                      if ($cartContainer.hasClass('active_link')) {
                        $('body').addClass('blocked-scroll');
                      } else {
                        $('body').addClass('blocked-scroll');
                      }

                      // Scroll to the top of the page unless the header is fixed
                      const header = document.getElementById('header');
                      if (header.classList.contains('mobile_nav-fixed--false')) {
                        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                      }
                    }
                  },
                });
              }
           });
        }
      }
      */
      /*********************** CART DRAWER PROGRESS BAR NEW TOP END JS ************************/
    }

    // First load refresh the cart using ajax
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success(cart) {
        // setTimeout(function () {
        refreshCart(cart);
      }
    })

    $('body').on('click', '.offer-remove', function () {
      var bestSellingProduct = $(this).parent().data('coffer');

      document.querySelector('.productid-' + bestSellingProduct).click();
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success(cart) {
          // setTimeout(function () {
          refreshCart(cart);
        }
      })

      //console.log(bestSellingProduct);
    });

    $("body").on("change", "[data-cart-quantity-input]", function () {
        const cartItem = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
      itemType: $(this).parents('[data-cart-item]').data('item-type'),
            quantity: $(this).val(),
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]"),
        };
        // Disable button after click to prevent multiple clicks
        $(this).parents(".product-quantity-box").find(".js-change-quantity").addClass("is-disabled");
        updateCartItemQuantity(cartItem, $(this));
    });

    $("body").on("click", "[data-remove-item]", function (e) {
        e.preventDefault();
        const cartItem = {
            lineID: $(this).parents("[data-cart-item]").data("line-id"),
            variantID: $(this).parents("[data-cart-item]").data("variant-id"),
      itemType: $(this).parents('[data-cart-item]').data('item-type'),
            quantity: 0,
            parentCartForm: $(this).parents("[data-cart-form]"),
            totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
            $element: $(this).parents("[data-cart-item]"),
        };
        cartItem.$element.addClass("animated fadeOutLeft");

        updateCartItemQuantity(cartItem, $(this));

        if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
            cartItem.$element.find("input").val("0");
            cartItem.parentCartForm.submit();
        }

        if (cartItem.parentCartForm.data("cart-form") === "mini-cart") {
            cartItem.$element.find("input").val("0");
        }
    });

    if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
      console.log("1")
      $(document).on('click', '.ajax-submit', async function (e) {
        console.log("2")
        e.preventDefault();
        console.log("3")
        const $addToCartForm = $(this).closest('form');
        const $addToCartBtn = $addToCartForm.find('.add_to_cart');

        // Refresh page on quick shop add to cart if on cart page
        if ($('body').hasClass('cart')) {
          $addToCartForm.submit();
        }
        if($(this).hasClass('trouser__bundle')){
          var bundlePro1 = $('#bundlePro1').val();
        var bundlePro2 = $('#bundlePro2').val();
        var bundlePro3 = $('#bundlePro3').val();
        var bundlePro4 = $('#bundlePro4').val();
        var productHandle = $('#productHandle').val();
        var productTitle = $('#productTitle').val();
        var productImage = $('#productImage').val();
        var sleSize = $('input[name="option-bundle"]:checked').val();
        var selSizeVal = $('input[name="option-bundle"]:checked').val().toLowerCase();
        var selSizeVal = selSizeVal.replace(' ', '_');
        var bundleVariantId1 = bundleVariantId2 = bundleVariantId3 = bundleVariantId4 = '';
        var bundleCounter = 0;
        if(bundlePro1 != ''){
          bundleVariantId1 = $('#'+bundlePro1+'__'+selSizeVal).val();
          bundleCounter++;
        }
        if(bundlePro2 != ''){
          bundleVariantId2 = $('#'+bundlePro2+'__'+selSizeVal).val();
          bundleCounter++;
        }
        if(bundlePro3 != ''){
          bundleVariantId3 = $('#'+bundlePro3+'__'+selSizeVal).val();
          bundleCounter++;
        }
        if(bundlePro4 != ''){
          bundleVariantId4 = $('#'+bundlePro4+'__'+selSizeVal).val();
          bundleCounter++;
        }
        var bundleQty = 1;
        //alert(bundleVariantId1+"=="+bundleVariantId2);
        if(bundlePro1 != '' || bundlePro2 != '' || bundlePro3 != '' || bundlePro4 != ''){
          // var itemArr = [
          //   {
          //     id: bundleVariantId1,
          //     quantity: 1,
          //     properties: { _bundlepCount: 2, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
          //   },
          //   {
          //     id: bundleVariantId2,
          //     quantity: 1,
          //     properties: { _bundlepCount: 2, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
          //   },
          // ];
          var itemArr = []
            if(bundleVariantId1 != ''){
              itemArr.push({
                id: bundleVariantId1,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId2 != ''){
              itemArr.push({
                id: bundleVariantId2,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId3 != ''){
              itemArr.push({
                id: bundleVariantId3,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId4 != ''){
              itemArr.push({
                id: bundleVariantId4,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {items:itemArr},
              beforeSend() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
              },
              success(res) {
                //console.log("ADD TO CART: ", res);
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                // window.setTimeout(() => {
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');

                // }, 10);

                //openMiniCart();
                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {
                    //console.log("GET CART: ", cart);
                    // setTimeout(function () {
                    refreshCart(cart);
                    if ($('body').hasClass('fancybox-active')) {
                      $.fancybox.close();
                    }

                    openMiniCart();

                    if ($('#header').is(':visible')) {
                      $('#header .cart-container').addClass('active_link');
                    }
                    else if ($('.sticky_nav--stick').length) {
                      $('.sticky_nav .cart-container').addClass('active_link');
                    }
                    else {
                      $('.top-bar .cart-container').addClass('active_link');
                    }


                    // block scrolling on mobile
                    if (window.PXUTheme.media_queries.medium.matches) {
                      const $cartContainer = $(this).parent();
                      if ($cartContainer.hasClass('active_link')) {
                        $('body').addClass('blocked-scroll');
                      } else {
                        $('body').addClass('blocked-scroll');
                      }

                      // Scroll to the top of the page unless the header is fixed
                      const header = document.getElementById('header');
                      if (header.classList.contains('mobile_nav-fixed--false')) {
                        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                      }
                    }
                  },
                });
              },
              error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                response = response.description;
                $('.warning').remove();

                const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
              },
            });
          }
        }
        else if($(this).hasClass('trouser__bundle__essential')){
          var bundlePro1 = $('#bundlePro1').val();
          var bundlePro2 = $('#bundlePro2').val();
          var productHandle = $('#productHandle').val();
          var productTitle = $('#productTitle').val();
          var productImage = $('#productImage').val();
          var sleSize = $('select[name="id_trouser"] option:selected').attr('data-value');
          //var sleSize = $('input[name="option-bundle"]:checked').val();
          //var selSizeVal = $('input[name="option-bundle"]:checked').val().toLowerCase();
          //var selSizeVal = selSizeVal.replace(' ', '_');
          var selSizeVal = sleSize;
          var bundleVariantId1 = bundleVariantId1 = '';
          if(bundlePro1 != ''){
            var bundleVariantId1 = $('#'+bundlePro1+'__'+selSizeVal).val();
          }
          if(bundlePro2 != ''){
            var bundleVariantId2 = $('#'+bundlePro2+'__'+selSizeVal).val();
          }
          //alert(bundleVariantId1+"=="+bundleVariantId2);
          var bundleQty = 1;
          if(bundlePro1 != '' && bundlePro2 != ''){
            var itemArr = [
              {
                id: bundleVariantId1,
                quantity: 1,
                properties: { _bundlepCount: 2, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle2', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              },
              {
                id: bundleVariantId2,
                quantity: 1,
                properties: { _bundlepCount: 2, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle2', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              },
            ];

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {items:itemArr},
              beforeSend() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
              },
              success(res) {
                //console.log("ADD TO CART: ", res);
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                // window.setTimeout(() => {
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                // }, 10);

                //openMiniCart();
                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {
                    //console.log("GET CART: ", cart);
                    // setTimeout(function () {
                    refreshCart(cart);
                    if ($('body').hasClass('fancybox-active')) {
                      $.fancybox.close();
                    }

                    openMiniCart();

                    if ($('#header').is(':visible')) {
                      $('#header .cart-container').addClass('active_link');
                    }
                    else if ($('.sticky_nav--stick').length) {
                      $('.sticky_nav .cart-container').addClass('active_link');
                    }
                    else {
                      $('.top-bar .cart-container').addClass('active_link');
                    }


                    // block scrolling on mobile
                    if (window.PXUTheme.media_queries.medium.matches) {
                      const $cartContainer = $(this).parent();
                      if ($cartContainer.hasClass('active_link')) {
                        $('body').addClass('blocked-scroll');
                      } else {
                        $('body').addClass('blocked-scroll');
                      }

                      // Scroll to the top of the page unless the header is fixed
                      const header = document.getElementById('header');
                      if (header.classList.contains('mobile_nav-fixed--false')) {
                        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                      }
                    }
                  },
                });
              },
              error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                response = response.description;
                $('.warning').remove();

                const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
              },
            });
          }
        }
        else if($(this).hasClass('trouser__four_bundle__essential')){
          var bundlePro1 = $('#bundlePro1').val();
          var bundlePro2 = $('#bundlePro2').val();
          var bundlePro3 = $('#bundlePro3').val();
          var bundlePro4 = $('#bundlePro4').val();
          var productHandle = $('#productHandle').val();
          var productTitle = $('#productTitle').val();
          var productImage = $('#productImage').val();
          var sleSize = $('select[name="id_trouser"] option:selected').attr('data-value');
          //var sleSize = $('input[name="option-bundle"]:checked').val();
          //var selSizeVal = $('input[name="option-bundle"]:checked').val().toLowerCase();
          //var selSizeVal = selSizeVal.replace(' ', '_');
          var selSizeVal = sleSize;
          var bundleVariantId1 = bundleVariantId1 = '';
          if(bundlePro1 != ''){
            var bundleVariantId1 = $('#'+bundlePro1+'__'+selSizeVal).val();
          }
          if(bundlePro2 != ''){
            var bundleVariantId2 = $('#'+bundlePro2+'__'+selSizeVal).val();
          }
          if(bundlePro3 != ''){
            var bundleVariantId3 = $('#'+bundlePro3+'__'+selSizeVal).val();
          }
          if(bundlePro4 != ''){
            var bundleVariantId4 = $('#'+bundlePro4+'__'+selSizeVal).val();
          }
          //alert(bundleVariantId1+"=="+bundleVariantId2);
          var bundleQty = 1;
          if(bundlePro1 != '' && bundlePro2 != '' && bundlePro3 != '' && bundlePro4 != ''){
            var itemArr = [
              {
                id: bundleVariantId1,
                quantity: 1,
                properties: { _bundlepCount: 4, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle3', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              },
              {
                id: bundleVariantId2,
                quantity: 1,
                properties: { _bundlepCount: 4, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle3', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              },
              {
                id: bundleVariantId3,
                quantity: 1,
                properties: { _bundlepCount: 4, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle3', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              },
              {
                id: bundleVariantId4,
                quantity: 1,
                properties: { _bundlepCount: 4, _bundleSizeVal: sleSize,_bundleQty: bundleQty, _bundleSize: 'bundle3', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              },
            ];

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {items:itemArr},
              beforeSend() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
              },
              success(res) {
                //console.log("ADD TO CART: ", res);
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                // window.setTimeout(() => {
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                // }, 10);

                //openMiniCart();
                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {
                    //console.log("GET CART: ", cart);
                    // setTimeout(function () {
                    refreshCart(cart);
                    if ($('body').hasClass('fancybox-active')) {
                      $.fancybox.close();
                    }

                    openMiniCart();

                    if ($('#header').is(':visible')) {
                      $('#header .cart-container').addClass('active_link');
                    }
                    else if ($('.sticky_nav--stick').length) {
                      $('.sticky_nav .cart-container').addClass('active_link');
                    }
                    else {
                      $('.top-bar .cart-container').addClass('active_link');
                    }


                    // block scrolling on mobile
                    if (window.PXUTheme.media_queries.medium.matches) {
                      const $cartContainer = $(this).parent();
                      if ($cartContainer.hasClass('active_link')) {
                        $('body').addClass('blocked-scroll');
                      } else {
                        $('body').addClass('blocked-scroll');
                      }

                      // Scroll to the top of the page unless the header is fixed
                      const header = document.getElementById('header');
                      if (header.classList.contains('mobile_nav-fixed--false')) {
                        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                      }
                    }
                  },
                });
              },
              error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                response = response.description;
                $('.warning').remove();

                const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
              },
            });
          }
        }
        else if($(this).hasClass('shirt__bundle')){
          var bundleQty = $(this).attr('data-qty');
          var bundlePro1 = $('#bundlePro1').val();
          var bundlePro2 = $('#bundlePro2').val();
          var bundlePro3 = $('#bundlePro3').val();
          var bundlePro4 = $('#bundlePro4').val();
          var productHandle = $('#productHandle').val();
          var productTitle = $('#productTitle').val();
          var productImage = $('#productImage').val();
          var sleSize = $('input[name="option-bundle"]:checked').val();
          var selSizeVal = $('input[name="option-bundle"]:checked').val().toLowerCase();
          var selSizeVal = selSizeVal.replace(' ', '_');
          var bundleVariantId1 = bundleVariantId2 = bundleVariantId3 = bundleVariantId4 = '';
          var bundleCounter = 0;
          if(bundlePro1 != ''){
            bundleVariantId1 = $('#'+bundlePro1+'__'+selSizeVal).val();
            bundleCounter++;
          }
          if(bundlePro2 != ''){
            bundleVariantId2 = $('#'+bundlePro2+'__'+selSizeVal).val();
            bundleCounter++;
          }
          if(bundlePro3 != ''){
            bundleVariantId3 = $('#'+bundlePro3+'__'+selSizeVal).val();
            bundleCounter++;
          }
          if(bundlePro4 != ''){
            bundleVariantId4 = $('#'+bundlePro4+'__'+selSizeVal).val();
            bundleCounter++;
          }
          var bundleNewCounter = (bundleCounter * bundleQty);
          // alert(bundleNewCounter+"===="+bundleQty);
          // alert(bundleVariantId1+"=="+bundleVariantId2+"=="+bundleVariantId3+"=="+bundleVariantId4);
          if(bundlePro1 != '' || bundlePro2 != '' || bundlePro3 != '' || bundlePro4 != ''){
            var itemArr = []
            if(bundleVariantId1 != ''){
              itemArr.push({
                id: bundleVariantId1,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle4', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId2 != ''){
              itemArr.push({
                id: bundleVariantId2,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle4', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId3 != ''){
              itemArr.push({
                id: bundleVariantId3,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle4', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId4 != ''){
              itemArr.push({
                id: bundleVariantId4,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle4', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            // var itemArr = [
            //   {
            //     id: bundleVariantId1,
            //     quantity: bundleQty,
            //     properties: { _bundlepCount: 2, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
            //   },
            //   {
            //     id: bundleVariantId2,
            //     quantity: bundleQty,
            //     properties: { _bundlepCount: 2, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
            //   },
            // ];

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {items:itemArr},
              beforeSend() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
              },
              success(res) {
                //console.log("ADD TO CART: ", res);
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                // window.setTimeout(() => {
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                // }, 10);

                //openMiniCart();
                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {
                    //console.log("GET CART: ", cart);
                    // setTimeout(function () {
                    refreshCart(cart);
                    if ($('body').hasClass('fancybox-active')) {
                      $.fancybox.close();
                    }

                    openMiniCart();

                    if ($('#header').is(':visible')) {
                      $('#header .cart-container').addClass('active_link');
                    }
                    else if ($('.sticky_nav--stick').length) {
                      $('.sticky_nav .cart-container').addClass('active_link');
                    }
                    else {
                      $('.top-bar .cart-container').addClass('active_link');
                    }


                    // block scrolling on mobile
                    if (window.PXUTheme.media_queries.medium.matches) {
                      const $cartContainer = $(this).parent();
                      if ($cartContainer.hasClass('active_link')) {
                        $('body').addClass('blocked-scroll');
                      } else {
                        $('body').addClass('blocked-scroll');
                      }

                      // Scroll to the top of the page unless the header is fixed
                      const header = document.getElementById('header');
                      if (header.classList.contains('mobile_nav-fixed--false')) {
                        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                      }
                    }
                  },
                });
              },
              error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                response = response.description;
                $('.warning').remove();

                const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
              },
            });
          }
        }
        else if($(this).hasClass('chino__bundle')){
          var bundleQty = $(this).attr('data-qty');
          var bundlePro1 = $('#bundlePro1').val();
          var bundlePro2 = $('#bundlePro2').val();
          var bundlePro3 = $('#bundlePro3').val();
          var bundlePro4 = $('#bundlePro4').val();
          var productHandle = $('#productHandle').val();
          var productTitle = $('#productTitle').val();
          var productImage = $('#productImage').val();
          var sleSize = $('input[name="option-bundle"]:checked').val();
          var selSizeVal = $('input[name="option-bundle"]:checked').val().toLowerCase();
          var selSizeVal = selSizeVal.replace(' ', '_');
          var bundleVariantId1 = bundleVariantId2 = bundleVariantId3 = bundleVariantId4 = '';
          var bundleCounter = 0;
          if(bundlePro1 != ''){
            bundleVariantId1 = $('#'+bundlePro1+'__'+selSizeVal).val();
            bundleCounter++;
          }
          if(bundlePro2 != ''){
            bundleVariantId2 = $('#'+bundlePro2+'__'+selSizeVal).val();
            bundleCounter++;
          }
          if(bundlePro3 != ''){
            bundleVariantId3 = $('#'+bundlePro3+'__'+selSizeVal).val();
            bundleCounter++;
          }
          if(bundlePro4 != ''){
            bundleVariantId4 = $('#'+bundlePro4+'__'+selSizeVal).val();
            bundleCounter++;
          }
          var bundleNewCounter = (bundleCounter * bundleQty);
          // alert(bundleNewCounter+"===="+bundleQty);
          // alert(bundleVariantId1+"=="+bundleVariantId2+"=="+bundleVariantId3+"=="+bundleVariantId4);
          if(bundlePro1 != '' || bundlePro2 != '' || bundlePro3 != '' || bundlePro4 != ''){
            var itemArr = []
            if(bundleVariantId1 != ''){
              itemArr.push({
                id: bundleVariantId1,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle5', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId2 != ''){
              itemArr.push({
                id: bundleVariantId2,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle5', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId3 != ''){
              itemArr.push({
                id: bundleVariantId3,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle5', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            if(bundleVariantId4 != ''){
              itemArr.push({
                id: bundleVariantId4,
                quantity: bundleQty,
                properties: { _bundlepCount: bundleNewCounter, _bundleQty: bundleQty, _bundleSizeVal: sleSize, _bundleSize: 'bundle5', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
              });
            }
            // var itemArr = [
            //   {
            //     id: bundleVariantId1,
            //     quantity: bundleQty,
            //     properties: { _bundlepCount: 2, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
            //   },
            //   {
            //     id: bundleVariantId2,
            //     quantity: bundleQty,
            //     properties: { _bundlepCount: 2, _bundleSizeVal: sleSize, _bundleSize: 'bundle1', _productHandle:productHandle, _productTitle:productTitle, _productImage:productImage },
            //   },
            // ];

            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: {items:itemArr},
              beforeSend() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
              },
              success(res) {
                //console.log("ADD TO CART: ", res);
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                // window.setTimeout(() => {
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                // }, 10);

                //openMiniCart();
                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {
                    //console.log("GET CART: ", cart);
                    // setTimeout(function () {
                    refreshCart(cart);
                    if ($('body').hasClass('fancybox-active')) {
                      $.fancybox.close();
                    }

                    openMiniCart();

                    if ($('#header').is(':visible')) {
                      $('#header .cart-container').addClass('active_link');
                    }
                    else if ($('.sticky_nav--stick').length) {
                      $('.sticky_nav .cart-container').addClass('active_link');
                    }
                    else {
                      $('.top-bar .cart-container').addClass('active_link');
                    }


                    // block scrolling on mobile
                    if (window.PXUTheme.media_queries.medium.matches) {
                      const $cartContainer = $(this).parent();
                      if ($cartContainer.hasClass('active_link')) {
                        $('body').addClass('blocked-scroll');
                      } else {
                        $('body').addClass('blocked-scroll');
                      }

                      // Scroll to the top of the page unless the header is fixed
                      const header = document.getElementById('header');
                      if (header.classList.contains('mobile_nav-fixed--false')) {
                        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                      }
                    }
                  },
                });
              },
              error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                response = response.description;
                $('.warning').remove();

                const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
              },
            });
          }
        }
        else{
          const cartRespBefore = await fetch('/cart.js');
          const cartBefore = await cartRespBefore.json();
          const lastQuantity = cartBefore.items.reduce((sum, item) => sum + item.quantity, 0);
          console.log("4")
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: $addToCartForm.serialize(),
              beforeSend() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
              },
              success() {
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');

                window.setTimeout(() => {
                  $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                  $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                  $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                }, 1000);

                $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  cache: false,
                  success(cart) {
                    //setTimeout(function () {
                      const newQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);

                      console.log('Old quantity', lastQuantity)
                      console.log('New quantity', newQuantity)

                      if(lastQuantity == newQuantity){
                        console.log('Error while adding a product. Trying again...')
                        e.target.click()
                      } else {
                        refreshCart(cart);
                        if ($('body').hasClass('fancybox-active')) {
                          $.fancybox.close();
                        }

                        openMiniCart();

                        if ($('#header').is(':visible')) {
                          $('#header .cart-container').addClass('active_link');
                        } else if ($('.sticky_nav--stick').length) {
                          $('.sticky_nav .cart-container').addClass('active_link');
                        } else {
                          $('.top-bar .cart-container').addClass('active_link');
                        }

                        // block scrolling on mobile
                        if (window.PXUTheme.media_queries.medium.matches) {
                          const $cartContainer = $(this).parent();
                          if ($cartContainer.hasClass('active_link')) {
                            $('body').addClass('blocked-scroll');
                          } else {
                            $('body').addClass('blocked-scroll');
                          }

                          // Scroll to the top of the page unless the header is fixed
                          const header = document.getElementById('header');
                          if (header.classList.contains('mobile_nav-fixed--false')) {
                            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                          }
                        }
                      }
                    //}, 500);
                  },
                });
              },
              error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`);
                response = response.description;
                $('.warning').remove();

                const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
                $addToCartForm.after(warning);
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
              },
            });
        }
        return false;
      });

      $(document).on('click', '.ajax-submit-up', function (e) {
        const $addToCartBtn = $('.cart-best-pro');
        var bundleVariantId1 = $(this).parent().parent().find('.select_variants').val();
        var qty = $(this).parent().find('.product-quantity-box').find('.quantity').val();
        var itemArr = [
          {
            id: bundleVariantId1,
            quantity: qty,
          }
        ];
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: {items:itemArr},
          beforeSend() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
          },
          success() {
            $addToCartBtn.find('.checkmark').addClass('checkmark-active');

            window.setTimeout(() => {
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
              $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            }, 1000);

            $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success(cart) {
                //setTimeout(function () {
                  refreshCart(cart);
                  if ($('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                  }

                  openMiniCart();

                  if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                  } else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                  } else {
                    $('.top-bar .cart-container').addClass('active_link');
                  }

                  // block scrolling on mobile
                  if (window.PXUTheme.media_queries.medium.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                      $('body').addClass('blocked-scroll');
                    } else {
                      $('body').addClass('blocked-scroll');
                    }

                    // Scroll to the top of the page unless the header is fixed
                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                    }
                  }
                //}, 500);
              },
            });
          },
          error(XMLHttpRequest) {
            let response = eval(`(${XMLHttpRequest.responseText})`);
            response = response.description;
            $('.warning').remove();

            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
          },
        });
      });

      $(document).on('click', '.ajax-submit-upsell-slider', function (e) {
        const $addToCartBtn = $('.cart-ajax-button');
        var bundleVariantId1 = $(this).parent().find('.select_variants').val();
        var itemArr = [
          {
            id: bundleVariantId1,
            quantity: 1,
          }
        ];
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: {items:itemArr},
          beforeSend() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
          },
          success() {
            $addToCartBtn.find('.checkmark').addClass('checkmark-active');

            window.setTimeout(() => {
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
              $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
            }, 1000);

            $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success(cart) {
                //setTimeout(function () {
                  refreshCart(cart);
                  if ($('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                  }

                  openMiniCart();

                  if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                  } else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                  } else {
                    $('.top-bar .cart-container').addClass('active_link');
                  }

                  // block scrolling on mobile
                  if (window.PXUTheme.media_queries.medium.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                      $('body').addClass('blocked-scroll');
                    } else {
                      $('body').addClass('blocked-scroll');
                    }

                    // Scroll to the top of the page unless the header is fixed
                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                    }
                  }
                //}, 500);
              },
            });
          },
          error(XMLHttpRequest) {
            let response = eval(`(${XMLHttpRequest.responseText})`);
            response = response.description;
            $('.warning').remove();

            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
          },
        });
      });

      //SHOP THE LOOK ON CHANGE AND CLICK ATC JS STAT
      $(document).on('click', '.shop_the_look_button_custom button', function(e) {
        e.preventDefault();

        var $addToCartBtn = $(this);

        // get first option (radio)
        var firstOption = $('input[name="shop_look_first_option_size"]:checked').val();
        var firstOption = $('select[name="shop_look_first_option_size"]').val();
        // get second option (dropdown)
        var secondOption = $('select[name="shop_look_second_option_size"]').val();

        if (!firstOption || !secondOption) {
          alert("Please select both options before adding to cart.");
          return;
        }

        var items = [
          { id: firstOption, quantity: 1 },
          { id: secondOption, quantity: 1 }
        ];

        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');

        // make add.js call
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: items }),
          dataType: 'json',
          contentType: 'application/json',
          success: function(data) {
            console.log("Added to cart:", data);

            $addToCartBtn.find('.checkmark').addClass('checkmark-active');
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');

            $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success: function(cart) {
                refreshCart(cart);

                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                openMiniCart();

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                if (window.PXUTheme.media_queries.medium.matches) {
                  var $cartContainer = $addToCartBtn.parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  var header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
                }
              }
            });
          },
          error: function(err) {
            console.error("Error:", err);
          }
        });
      });

      $('body').on('change', '.product-custom-atc', function (e) {
        console.log("ddddd")
          e.preventDefault();

          //add loading
          let curbutton = $(this)

          if($('body').hasClass('btn_atc_vtwo')){
            curbutton.parent('.add-to-cart-form-round').addClass('hide__atc');
            curbutton.parent().parent().find('.add__custom_loader').addClass('show__loader');
          }

          const $addToCartForm = $(this).closest('form');
          //const $addToCartBtn = $addToCartForm.find('.add_to_cart');

          // Refresh page on quick shop add to cart if on cart page
          if ($('body').hasClass('cart')) {
            $addToCartForm.submit();
          }

          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: $addToCartForm.serialize(),
            beforeSend() {
              // $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
              // $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');

              curbutton.addClass('is-loading');
              curbutton.attr('disabled', 'disabled').addClass('disabled');
            },
            success(res) {
              //console.log("ADD TO CART: ", res);
              // $addToCartBtn.find('.checkmark').addClass('checkmark-active');

              // window.setTimeout(() => {
              // $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              // $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
              // $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');

              curbutton.removeClass('is-loading');
              curbutton.removeAttr('disabled');
              curbutton.removeClass('disabled');
              if(curbutton.length>0){
                curbutton[0].selectedIndex = 0;
              }
              // }, 10);

              if($('body').hasClass('btn_atc_vtwo')){
                curbutton.parent('.add-to-cart-form-round').removeClass('hide__atc');
                curbutton.parent('div').find('.add__custom_loader').removeClass('show__loader');
              }

              //openMiniCart();
              $.ajax({
                url: '/cart.js',
                dataType: 'json',
                cache: false,
                success(cart) {
                  //console.log("GET CART: ", cart);
                  // setTimeout(function () {
                  refreshCart(cart);
                  if ($('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                  }

                  openMiniCart();

                  if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                  }
                  else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                  }
                  else {
                    $('.top-bar .cart-container').addClass('active_link');
                  }


                  // block scrolling on mobile
                  if (window.PXUTheme.media_queries.medium.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                      $('body').addClass('blocked-scroll');
                    } else {
                      $('body').addClass('blocked-scroll');
                    }

                    // Scroll to the top of the page unless the header is fixed
                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                    }
                  }
                },
              });
            },
            error(XMLHttpRequest) {
              let response = eval(`(${XMLHttpRequest.responseText})`);
              response = response.description;
              $('.warning').remove();

              const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
              $addToCartForm.after(warning);
              // $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              // $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
            },
          });

          return false;
        });

      //SHOP THE LOOK ON CHANGE AND CLICK ATC JS END

      //cart drawer product tab add to cart start here
      $(document).on('click', '.cartrecom-product--addcart', function (e) {
          e.preventDefault();
          //add loading
          let curbutton = $(this)

          var pName = $(this).attr('data-pname');
          var dataUpsellLab = $(this).attr('data-upsellab');
          var dataGift = $(this).attr('data-gift');
          var vid = $(this).parent('div').find('.cartrecom-product-variant-select option:selected').val();
          if(dataUpsellLab!="" && dataUpsellLab!=undefined){
            var itemArr = [
                {
                  id: vid,
                  quantity: 1,
                  properties: { _dataUpsellLab: 'twenty'},
                }
              ];
          }
          else if(dataGift!="" && dataGift!=undefined){
            var itemArr = [
                {
                  id: vid,
                  quantity: 1,
                  properties: { _dataGift: 'free'},
                }
              ];
          }
          else{
          var itemArr = [
                {
                  id: vid,
                  quantity: 1,
                }
              ];
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'upsell_add_to_cart',
            product_name: pName  // This needs to be dynamically populated based on the upsell product
          });

          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {items:itemArr},
            beforeSend() {
              curbutton.find('button').addClass('is-loading');
              curbutton.find('button').attr('disabled', 'disabled').addClass('disabled');
            },
            success(res) {
              //console.log("ADD TO CART: ", res['items']);
              curbutton.find('button').removeClass('is-loading');
              curbutton.find('button').removeAttr('disabled', 'disabled').removeClass('disabled');
              $("[data-pid='" + res['items'][0]['product_id'] + "']").hide();
              $("[data-ptid='" + res['items'][0]['product_id'] + "']").hide();
             tabHideCartAddedProductDrawer();
              //openMiniCart();
              $.ajax({
                url: '/cart.js',
                dataType: 'json',
                cache: false,
                success(cart) {
                  //console.log("GET CART: ", cart);
                  // setTimeout(function () {
                  refreshCart(cart);
                  if ($('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                  }

                  openMiniCart();

                  if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                  }
                  else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                  }
                  else {
                    $('.top-bar .cart-container').addClass('active_link');
                  }
                  // block scrolling on mobile
                  if (window.PXUTheme.media_queries.medium.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                      $('body').addClass('blocked-scroll');
                    } else {
                      $('body').addClass('blocked-scroll');
                    }

                    // Scroll to the top of the page unless the header is fixed
                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                    }
                  }
                },
              });
            },
            error(XMLHttpRequest) {
              let response = eval(`(${XMLHttpRequest.responseText})`);
              response = response.description;
              $('.warning').remove();

              const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
              $addToCartForm.after(warning);
              // $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              // $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
            },
          });

          return false;
        });
    }

    window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
    switch (selectorIndex) {
        case 0:
            var key = "root";
            break;
        case 1:
            var key = $(`${parent} .single-option-selector:eq(0)`).val();
            break;
        case 2:
            var key = $(`${parent} .single-option-selector:eq(0)`).val();
            key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
    }

    const availableOptions = Shopify.optionsMap[key];
    $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
        if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
            $(this).removeClass("soldout").find(":radio").removeAttr("disabled", "disabled").removeAttr("checked");
        } else {
            $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled");
        }
    });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
    // Building our mapping object.
    window.Shopify.optionsMap = {};
    for (let i = 0; i < product.variants.length; i++) {
        const variant = product.variants[i];
        if (variant.available) {
            // Gathering values for the 1st drop-down.
            window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
            window.Shopify.optionsMap.root.push(variant.option1);
            window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                const key = variant.option1;
                window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
                window.Shopify.optionsMap[key].push(variant.option2);
                window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                const key = `${variant.option1} / ${variant.option2}`;
                window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
                window.Shopify.optionsMap[key].push(variant.option3);
                window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
            }
        }
    }
    // Update options right away.
    window.Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(`${parent} .single-option-selector:eq(0)`).change(() => {
        window.Shopify.updateOptionsInSelector(1, parent);
        if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
    // When there is an update in the second dropdown.
    $(`${parent} .single-option-selector:eq(1)`).change(() => {
        if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
    if (value) {
        return $("<div/>").text(value).html();
    }
    return "";
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t, e) {
    const o = t.toFixed(e).toString();
    return o.match(/^\.\d+/) ? `0${o}` : o;
}
if (typeof window.Shopify === "undefined") window.Shopify = {};
(window.Shopify.each = function (t, e) {
    for (let o = 0; o < t.length; o++) e(t[o], o);
}),
    (window.Shopify.map = function (t, e) {
        for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
        return o;
    }),
    (window.Shopify.arrayIncludes = function (t, e) {
        for (let o = 0; o < t.length; o++) if (t[o] == e) return !0;
        return !1;
    }),
    (window.Shopify.uniq = function (t) {
        for (var e = [], o = 0; o < t.length; o++) window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
        return e;
    }),
    (window.Shopify.isDefined = function (t) {
        return typeof t === "undefined" ? !1 : !0;
    }),
    (window.Shopify.getClass = function (t) {
        return Object.prototype.toString.call(t).slice(8, -1);
    }),
    (window.Shopify.extend = function (t, e) {
        function o() {}
        (o.prototype = e.prototype), (t.prototype = new o()), (t.prototype.constructor = t), (t.baseConstructor = e), (t.superClass = e.prototype);
    }),
    (window.Shopify.locationSearch = function () {
        return window.location.search;
    }),
    (window.Shopify.locationHash = function () {
        return window.location.hash;
    }),
    (window.Shopify.replaceState = function (t) {
        window.history.replaceState({}, document.title, t);
    }),
    (window.Shopify.urlParam = function (t) {
        const e = RegExp(`[?&]${t}=([^&#]*)`).exec(window.Shopify.locationSearch());
        return e && decodeURIComponent(e[1].replace(/\+/g, " "));
    }),
    (window.Shopify.newState = function (t, e) {
        let o;
        return (
            (o = window.Shopify.urlParam(t) ? window.Shopify.locationSearch().replace(RegExp(`(${t}=)[^&#]+`), `$1${e}`) : window.Shopify.locationSearch() === "" ? `?${t}=${e}` : `${window.Shopify.locationSearch()}&${t}=${e}`),
            o + window.Shopify.locationHash()
        );
    }),
    (window.Shopify.setParam = function (t, e) {
        window.Shopify.replaceState(window.Shopify.newState(t, e));
    }),
    (window.Shopify.Product = function (t) {
        window.Shopify.isDefined(t) && this.update(t);
    }),
    (window.Shopify.Product.prototype.update = function (t) {
        for (property in t) this[property] = t[property];
    }),
    (window.Shopify.Product.prototype.optionNames = function () {
        return window.Shopify.getClass(this.options) == "Array" ? this.options : [];
    }),
    (window.Shopify.Product.prototype.optionValues = function (t) {
        if (!window.Shopify.isDefined(this.variants)) return null;
        const e = window.Shopify.map(this.variants, (e) => {
            const o = `option${t + 1}`;
            return void 0 == e[o] ? null : e[o];
        });
        return e[0] == null ? null : window.Shopify.uniq(e);
    }),
    (window.Shopify.Product.prototype.getVariant = function (t) {
        let e = null;
        return t.length != this.options.length
            ? e
            : (window.Shopify.each(this.variants, (o) => {
                  for (var i = !0, r = 0; r < t.length; r++) {
                      const n = `option${r + 1}`;
                      o[n] != t[r] && (i = !1);
                  }
                  return i == 1 ? void (e = o) : void 0;
              }),
              e);
    }),
    (window.Shopify.Product.prototype.getVariantById = function (t) {
        for (let e = 0; e < this.variants.length; e++) {
            const o = this.variants[e];
            if (t == o.id) return o;
        }
        return null;
    }),
    (window.Shopify.money_format = "$"),
    (window.Shopify.formatMoney = function (t, e) {
        function o(t, e) {
            return typeof t === "undefined" ? e : t;
        }
        function i(t, e, i, r) {
            if (((e = o(e, 2)), (i = o(i, ",")), (r = o(r, ".")), isNaN(t) || t == null)) return 0;
            t = (t / 100).toFixed(e);
            const n = t.split(".");
            const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`);
            const s = n[1] ? r + n[1] : "";
            return a + s;
        }
        typeof t === "string" && (t = t.replace(".", ""));
        let r = "";
        const n = /\{\{\s*(\w+)\s*\}\}/;
        const a = e || this.money_format;
        switch (a.match(n)[1]) {
            case "amount":
                r = i(t, 2);
                break;
            case "amount_no_decimals":
                r = i(t, 0);
                break;
            case "amount_with_comma_separator":
                r = i(t, 2, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                r = i(t, 2, "'", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                r = i(t, 0, ".", ",");
        }
        return a.replace(n, r);
    }),
    (window.Shopify.OptionSelectors = function (t, e) {
        return (
            (this.selectorDivClass = "selector-wrapper"),
            (this.selectorClass = "single-option-selector"),
            (this.variantIdFieldIdSuffix = "-variant-id"),
            (this.variantIdField = null),
            (this.historyState = null),
            (this.selectors = []),
            (this.domIdPrefix = t),
            (this.product = new window.Shopify.Product(e.product)),
            (this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}),
            this.replaceSelector(t),
            this.initDropdown(),
            e.enableHistoryState && (this.historyState = new window.Shopify.OptionSelectors.HistoryState(this)),
            !0
        );
    }),
    (window.Shopify.OptionSelectors.prototype.initDropdown = function () {
        const t = { initialLoad: !0 };
        const e = this.selectVariantFromDropdown(t);
        if (!e) {
            const o = this;
            setTimeout(() => {
                o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t);
            });
        }
    }),
    (window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) {
        this.selectors[0].element.onchange(t);
    }),
    (window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) {
        const e = this.selectVariantFromParams(t);
        e || this.selectVariantFromDropdown(t);
    }),
    (window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
        const e = document.getElementById(t);
        const o = e.parentNode;
        window.Shopify.each(this.buildSelectors(), (t) => {
            o.insertBefore(t, e);
        }),
            (e.style.display = "none"),
            (this.variantIdField = e);
    }),
    (window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
        let e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
        if ((e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e)) return !1;
        const o = e.value;
        return this.selectVariant(o, t);
    }),
    (window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
        const e = window.Shopify.urlParam("variant");
        return this.selectVariant(e, t);
    }),
    (window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
        const o = this.product.getVariantById(t);
      console.log(o,e)
        if (o == null) return !1;
        for (let i = 0; i < this.selectors.length; i++) {
            const r = this.selectors[i].element;
            const n = r.getAttribute("data-option");
            const a = o[n];
            a != null && this.optionExistInSelect(r, a) && (r.value = a);
        }
        return typeof jQuery !== "undefined" ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0;
    }),
    (window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
        for (let o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0;
    }),
    (window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
        window.Shopify.isDefined(e) && this.setMessageElement(e), (this.domIdPrefix = `product-${this.product.id}-variant-selector`);
        const o = document.getElementById(t);
        window.Shopify.each(this.buildSelectors(), (t) => {
            o.appendChild(t);
        });
    }),
    (window.Shopify.OptionSelectors.prototype.buildSelectors = function () {
        for (let t = 0; t < this.product.optionNames().length; t++) {
            const e = new window.Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
            (e.element.disabled = !1), this.selectors.push(e);
        }
        const o = this.selectorDivClass;
        const i = this.product.optionNames();
        const r = window.Shopify.map(this.selectors, (t) => {
            const e = document.createElement("div");
            if ((e.setAttribute("class", o), i.length > 1)) {
                const r = document.createElement("label");
                (r.htmlFor = t.element.id), (r.innerHTML = t.name), e.appendChild(r);
            }
            return e.appendChild(t.element), e;
        });
        return r;
    }),
    (window.Shopify.OptionSelectors.prototype.selectedValues = function () {
        for (var t = [], e = 0; e < this.selectors.length; e++) {
            const o = this.selectors[e].element.value;
            t.push(o);
        }
        return t;
    }),
    (window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
        const o = this.selectedValues();
        const i = this.product.getVariant(o);
        i ? ((this.variantIdField.disabled = !1), (this.variantIdField.value = i.id)) : (this.variantIdField.disabled = !0), this.onVariantSelected(i, this, e), this.historyState != null && this.historyState.onVariantChange(i, this, e);
    }),
    (window.Shopify.OptionSelectorsFromDOM = function (t, e) {
        const o = e.optionNames || [];
        const i = e.priceFieldExists || !0;
        const r = e.delimiter || "/";
        const n = this.createProductFromSelector(t, o, i, r);
        (e.product = n), window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
    }),
    window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM, window.Shopify.OptionSelectors),
    (window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
        if (!window.Shopify.isDefined(o)) var o = !0;
        if (!window.Shopify.isDefined(i)) var i = "/";
        const r = document.getElementById(t);
        const n = r.childNodes;
        let a = (r.parentNode, e.length);
        const s = [];
        window.Shopify.each(n, (t, r) => {
            if (t.nodeType == 1 && t.tagName.toLowerCase() == "option") {
                const n = t.innerHTML.split(new RegExp(`\\s*\\${i}\\s*`));
                e.length == 0 && (a = n.length - (o ? 1 : 0));
                const p = n.slice(0, a);
                const l = o ? n[a] : "";
                const c =
                    (t.getAttribute("value"),
                    {
                        available: t.disabled ? !1 : !0,
                        id: parseFloat(t.value),
                        price: l,
                        option1: p[0],
                        option2: p[1],
                        option3: p[2],
                    });
                s.push(c);
            }
        });
        const p = { variants: s };
        if (e.length == 0) {
            p.options = [];
            for (let l = 0; a > l; l++) p.options[l] = `option ${l + 1}`;
        } else p.options = e;
        return p;
    }),
    (window.Shopify.SingleOptionSelector = function (t, e, o, i) {
        (this.multiSelector = t), (this.values = i), (this.index = e), (this.name = o), (this.element = document.createElement("select"));
        for (let r = 0; r < i.length; r++) {
            const n = document.createElement("option");
            (n.value = i[r]), (n.innerHTML = i[r]), this.element.appendChild(n);
        }
        return (
            this.element.setAttribute("class", this.multiSelector.selectorClass),
            this.element.setAttribute("data-option", `option${e + 1}`),
            (this.element.id = `${t.domIdPrefix}-option-${e}`),
            (this.element.onchange = function (o, i) {
                (i = i || {}), t.updateSelectors(e, i);
            }),
            !0
        );
    }),
    (window.Shopify.Image = {
        preload(t, e) {
            for (let o = 0; o < t.length; o++) {
                const i = t[o];
                this.loadImage(this.getSizedImageUrl(i, e));
            }
        },
        loadImage(t) {
            new Image().src = t;
        },
        switchImage(t, e, o) {
            if (t && e) {
                const i = this.imageSize(e.src);
                const r = this.getSizedImageUrl(t.src, i);
                o ? o(r, t, e) : (e.src = r);
            }
        },
        imageSize(t) {
            const e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
            return e != null ? e[1] : null;
        },
        getSizedImageUrl(t, e) {
            if (e == null) return t;
            if (e == "master") return this.removeProtocol(t);
            const o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (o != null) {
                const i = t.split(o[0]);
                const r = o[0];
                return this.removeProtocol(`${i[0]}_${e}${r}`);
            }
            return null;
        },
        removeProtocol(t) {
            return t.replace(/http(s)?:/, "");
        },
    }),
    (window.Shopify.OptionSelectors.HistoryState = function (t) {
        this.browserSupports() && this.register(t);
    }),
    (window.Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
        window.addEventListener("popstate", (e) => {
            t.selectVariantFromParamsOrDropdown({ popStateCall: !0 });
        });
    }),
    (window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) {
        this.browserSupports() && (!t || o.initialLoad || o.popStateCall || window.Shopify.setParam("variant", t.id));
    }),
    (window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
        return window.history && window.history.replaceState;
    });

$(document).on("shopify:block:select", (e) => {
    const { blockId } = e.detail;
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass("shopify-section--slideshow") || $parentSection.hasClass("shopify-section--testimonials") || $parentSection.hasClass("shopify-section--shoppable-image--slider-enabled")) {
        sliderBlock.select(blockId, $parentSection);
    }
});

$(document).on("shopify:block:deselect", (e) => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass("shopify-section--slideshow") || $parentSection.hasClass("shopify-section--testimonials")) {
        window.sliderBlock.deselect($parentSection);
    }
});

$(document).on("shopify:section:reorder", (e) => {
    window.utils.initializeSectionWrapper();
});

$(document).on("shopify:section:load", (e) => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.searchAutocomplete.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
        window.newsletter_popup.init();
    }

    if ($parentSection.hasClass("shopify-section--article-template")) {
        window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass("shopify-section--blog-template")) {
        window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass("shopify-section--product-sidebar")) {
        window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass("shopify-section--page-gallery-template")) {
        window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass("shopify-section--gallery")) {
        window.gallery.init();
    }

    if ($parentSection.hasClass("shopify-section--page-faq-template") || $parentSection.hasClass("shopify-section--faq")) {
        window.accordion.init();
    }

    if ($parentSection.hasClass("shopify-section--cart-template")) {
        window.cart.init();
    }

    if ($parentSection.hasClass("shopify-section--featured-promotions")) {
        window.featuredPromotions.init();
    }

    if ($parentSection.hasClass("shopify-section--slideshow")) {
        window.slideshow.init();
    }

    if ($parentSection.hasClass("shopify-section--testimonials")) {
        window.testimonials.init();
    }

    if ($parentSection.hasClass("shopify-section--featured-product")) {
        window.productPage.init();
        window.productPage.runOptionSelector($parentSection);
        window.videoFeature.init();
        window.productPage.productSwatches();
    }

    if ($parentSection.hasClass("shopify-section--map")) {
        window.map.init();
    }

    if ($parentSection.hasClass("shopify-section--logo-list")) {
        window.logoList.init();
    }

    if ($parentSection.hasClass("shopify-section--shoppable-image")) {
        window.shoppableImage.init();
    }

    if ($parentSection.hasClass("shopify-section--featured-collection")) {
        window.featuredCollection.init();
        window.productPage.init();
        window.productPage.runOptionSelector($parentSection);
        window.videoFeature.init();
    }

    if ($parentSection.hasClass("shopify-section--video")) {
        window.video.init();
    }

    if ($parentSection.hasClass("shopify-section--product-template") || $parentSection.hasClass("shopify-section--quick-shop")) {
        window.productPage.init();
        window.productPage.runOptionSelector($parentSection);
        window.videoFeature.init();
        window.productPage.productSwatches();
        window.recentlyViewed.init();
    }

    if ($parentSection.hasClass("shopify-section--recommended-products")) {
        window.productPage.init();
    }

    if ($parentSection.hasClass("shopify-section--recently-viewed-products")) {
        window.recentlyViewed.init();
    }

    if ($parentSection.hasClass("shopify-section--article-template")) {
        if (window.location.pathname.indexOf("/comments") != -1) {
            $("html,body").animate({ scrollTop: $("#new-comment").offset().top - 140 }, "slow");
        }
    }

    if ($parentSection.hasClass("shopify-section--collection-template")) {
        window.collectionSidebarFilter.init();
        window.productPage.init();
        window.productPage.runOptionSelector($parentSection);
        window.sidebarAccordions.init();
        window.recentlyViewed.init();
    }

    if ($parentSection.hasClass("shopify-section--contact-section")) {
        window.map.init();
    }

    if ($parentSection.hasClass("shopify-section--search-template")) {
        if (window.PXUTheme.theme_settings.enable_autocomplete) {
            window.searchAutocomplete.init();
        }
        window.collectionSidebarFilter.init();
        window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass("shopify-section--header")) {
        window.meganavManager.injectAll();
        window.header.init();
    }

    if ($parentSection.hasClass("shopify-section--mega-menu")) {
        window.meganavManager.add($parentSection[0]);
    }
});

$(document).on("shopify:section:unload", (e) => {
    const $target = $(e.target);
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass("shopify-section--header")) {
        window.header.unload($target);
    }

    if ($parentSection.hasClass("shopify-section--slideshow")) {
        window.slideshow.unload($target);
    }

    if ($parentSection.hasClass("shopify-section--logo-list")) {
        window.logoList.unload($parentSection.find("[data-logo-wrapper]"));
    }

    if ($parentSection.hasClass("shopify-section--testimonials")) {
        window.testimonials.unload($target);
    }

    if ($parentSection.hasClass("shopify-section--shoppable-image")) {
        window.shoppableImage.unload($target);
    }

    if ($parentSection.hasClass("shopify-section--search")) {
        window.searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass("shopify-section--product-template")) {
        window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass("shopify-section--featured-product")) {
        window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass("shopify-section--mega-menu")) {
        window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
        window.utils.initializeSectionWrapper();
    });
});

$(document).on("shopify:section:select", (e) => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass("shopify-section--mega-menu")) {
        window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass("shopify-section--logo-list")) {
        window.logoList.init();
    }

    if ($parentSection.hasClass("shopify-section--featured-collection")) {
        window.featuredCollection.unload($parentSection);
        window.featuredCollection.init();
    }

    const evt = document.createEvent("UIEvents");
    evt.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document).on("shopify:section:deselect", (e) => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass("shopify-section--mega-menu")) {
        window.meganavManager.deselect();
    }
});

$(document).ready(function () {
    $(".pro-form option").each(function () {
        let val = $(this).data("value");
        let av = $(this).data("av");
        if (av == "disabled") {
            $(".single-option-selector option[value=" + val + "]").attr("disabled", "disabled");
            $(".single-option-selector option[value=" + val + "]").append(" - Out of stock");
        }
    });
});
$(document).ready(function () {
    $(".custom-option.pro-form option").each(function () {
        let _text = $(this).text();
        if ($(this).data("avv") == false) {
            $(`.single-option-selector option[value="${_text}"]`).text(`Out of stock- ${_text}`);
            $(`.single-option-selector option[value="${_text}"]`).attr("disabled", "disabled");
            $(`.single-option-selector option[value="${_text}"]`).css("background", "#ebebeb").css("color", "#b39f9f");
        }
    });
    $(".pro-form.last-chance option").each(function () {
        let _text = $(this).text();
        // alert(_text);
        if ($(this).data("avv") == false) {
            $(this).text(`Out of stock- ${_text}`);
            $(this).attr("disabled", "disabled");
            $(this).css("background", "#ebebeb").css("color", "#b39f9f");
        }
    });
});

$(document).ready(function () {
    $(".icon-right.search-div").mouseover(function () {
        //$('.dropdown_container.center').addClass('open-search');
        $(".dropdown_container.center").show();
    });

    $(document).mouseup(function (e) {
        var container = $(".dropdown_container.center");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.hide();
        }
    });
});

$(document).ready(function(){
    function adjustMenuHeight() {
        var headerHeight = $('#header').outerHeight(); // Get the height of the header including padding
        var windowHeight = window.innerHeight; // Get the height of the window
        var menuHeight = windowHeight - headerHeight; // Subtract header height from window height

        $('.mobile-menu-container').css('height', menuHeight + 'px'); // Apply the new height to the menu drawer
    }

    // Run function on document ready
    adjustMenuHeight();

    // Also run on window resize or orientation change
    $(window).on('resize orientationchange', function() {
        adjustMenuHeight();
    });
});

// START :: cart recommended tab [snippets/cart-custom-drawer.liquid]
jQuery(document).ready(function() {
    // Handle tab click
    jQuery(document).on("click", ".cart_recommended .cart_recomtab_link", function() {
       var productClass1 = jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recommended').hasClass('cartrecomand-v1') ? 'cartrecom-product-1' : 'cartrecom-product-2';
       var mainClass1= jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recommended').hasClass('cartrecomand-v1') ? 'cartrecomand-v1' : 'cartrecomand-v2'
        var tab_id = jQuery(this).attr('data-tab');
        jQuery('.cart_recomtab_link, .cart_recom_content').removeClass('current');
        jQuery('.tab_active').val(tab_id);
        jQuery('[data-tab="'+tab_id+'"], .'+tab_id).addClass('current');
        setTimeout(function(){
          jQuery('.'+mainClass1).find('.cart_recom_content'+'.'+tab_id+'.current').removeAttr('style');
        },100)
    });

    // Initial tab check on load
    //if($('.cart_recommended').hasClass('cartrecomand-v1') || $('.cart_recommended').hasClass('cartrecomand-v2')){
      setTimeout(() => tabHideCartAddedProductDrawer(1), 1500);
    //}
});

function tabHideCartAddedProductDrawer(loadtime = '') {
    let flagcount1 = 0;
    let flagdefault=0;
    const productClass = jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recommended').hasClass('cartrecomand-v1') ? 'cartrecom-product-1' : 'cartrecom-product-2';
    const mainClass = jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recommended').hasClass('cartrecomand-v1') ? 'cartrecomand-v1' : 'cartrecomand-v2';
    //if (loadtime === 1){
   setTimeout(function(){
     if (loadtime === 1){
      activateFirstVisibleTab(mainClass,productClass);
     }
    //}

    var currentActiveTab = jQuery('.tab_active').val();
    jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recom_content').each(function() {
        var totalLength = jQuery(this).find(`.${productClass}[style="display: none;"]`).length;
        var tabid = jQuery(this).attr('id');
        var bundleCount = jQuery('.'+mainClass).find('.'+tabid+' .'+'cartrecom-grid').attr('data-pcount');
        // = (totalLength/4);
        //console.log("count",totalLength+'==='+bundleCount);
        if(parseInt(totalLength)===parseInt(bundleCount)){
            jQuery(this).removeClass('current');
            jQuery(this).addClass("full-products");
            jQuery(`[data-tab="${tabid}"], .${tabid}`).removeClass('current').hide();  // Hide the tab link and content
            if(flagcount1 === 0) {
               var currentTotallength = jQuery('.'+mainClass+' .'+currentActiveTab).find(`.${productClass}[style="display: none;"]`).length;
               currentTotallength = parseInt(currentTotallength/4);
              //console.log("currentTotallength",currentTotallength,bundleCount);
               if(currentTotallength==bundleCount){
                 const $nextTab = jQuery(`[data-tab="${tabid}"]`).next('.cart_recomtab_link');
                  flagdefault=1;
                  if ($nextTab.length) {
                      $nextTab.addClass('current');
                      jQuery(`.${$nextTab.attr('data-tab')}`).addClass("current");
                     flagcount1++;
                  }
                 }
            }
        }
    });

    if (flagcount1 !== 0) {
        jQuery(`.${productClass}.current`).each(function() {
            if(!jQuery(this).hasClass("full-products")){
                const hideTabid = jQuery(this).attr('id');
                jQuery(this).removeClass("current");
                jQuery(`[data-tab="${hideTabid}"]`).removeClass('current');
            }
        });
    }

  },500);
  //activateFirstVisibleTab(mainClass,productClass);
}

function tabClickHideCartDrawer() {
    const bundleCount = 6;
    const productClass = jQuery('.cart_recommended').hasClass('cartrecomand-v1') ? 'cartrecom-product-1' : 'cartrecom-product-2';
    jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recom_content').each(function() {
        var totalLength = jQuery(this).find(`.${productClass}[style="display: none;"]`).length;
        if (totalLength === bundleCount) {
            jQuery('.cart_recomtab_link, .cart_recom_content').removeClass('current').removeAttr('style');
            jQuery(this).removeClass("current");
            const tabid = jQuery(this).attr('id');
            jQuery(`[data-tab="${tabid}"]`).removeClass('current').hide();  // Hide the tab link and content
        }
    });
}

function activateFirstVisibleTab(mainclass,productClass) {
    var flagcheck=0;
  setTimeout(function(){
    jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recom_content').each(function(){
      if(jQuery(this).hasClass('full-products')==false){
        if(flagcheck==0){
          var showTabid = jQuery(this).attr('id');
          jQuery(`[data-tab="${showTabid}"]`).addClass('current');
          jQuery('.tab_active').val(showTabid);
          jQuery('.cart_recommended.'+mainclass).find('.'+showTabid).addClass('current');
          //jQuery('.cart_recommended.'+mainclass).find('.'+showTabid).find('.cartrecom-product.'+productClass).show();
          flagcheck++;
        }
      }else{
        jQuery('.tab_active').val('cart_recomtab-1');
      }
    });
  },100);
}

jQuery(document).on("click",".js-cart-remove-btn",function(){
  var productCartID = jQuery(this).attr('data-ctpid');
  var productClass1 = jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recommended').hasClass('cartrecomand-v1') ? 'cartrecom-product-1' : 'cartrecom-product-2';
  var mainClass1= jQuery('[data-cart-form="mini-cart"]').eq(0).find('.cart_recommended').hasClass('cartrecomand-v1') ? 'cartrecomand-v1' : 'cartrecomand-v2';
  //console.log("length get",jQuery('.cart_recom_content').find('[data-pid="'+productCartID+'"]').length);
  if(jQuery('.cart_recom_content').find('[data-pid="'+productCartID+'"]').length){
    jQuery('.'+mainClass1).find('.cart_recom_content').find('.'+productClass1+'[data-pid="'+productCartID+'"]').show();
    var tabId = jQuery('.'+mainClass1).find('.cart_recom_content').find('.'+productClass1+'[data-pid="'+productCartID+'"]').parent().parent().attr('id');
    jQuery('[data-tab="'+tabId+'"]').show();
    //jQuery('.'+mainClass1).find('.cart_recom_content').find('.'+productClass1+'[data-pid="'+productCartID+'"]').parent().parent().show();
    jQuery('.'+mainClass1).find('.cart_recom_content').find('.'+productClass1+'[data-pid="'+productCartID+'"]').parent().parent().removeClass('full-products');
  }
  if(jQuery('.gwp_promo_product.cartrecom-product[data-pid="'+productCartID+'"]').length>0){
    setTimeout(function(){
      jQuery('.gwp_promo_product.cartrecom-product[data-pid="'+productCartID+'"]').show();
    },1000);
  }
});
// END :: cart recommended tab [snippets/cart-custom-drawer.liquid]

jQuery(document).ready(function() {
 jQuery('.abar_rotate').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
  });
});

jQuery(document).ready(function() {
  jQuery('.cbslider').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 399,
        settings: {
          slidesToShow: 5.3,
          slidesToScroll: 1,
          variableWidth: false,
        }
      }
    ]
  });

  $('.bfcmreview--grid').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding:'30px',
        }
      }
    ]
  });
});

/* COLLECTION OFFER POPUP -- START */

$(document).ready(function() {
  var openBtn = $('.cf_box_openbtn');
  var closeBtn = $('.cf_popup_close');

  // Only add event listeners if the elements exist
  if (openBtn.length) {
    openBtn.on('click', function() {
      $('.collection_offer_popup').css('display', 'block');
      $('body').addClass('collection_offer_popup_active');
    });
  }

  if (closeBtn.length) {
    closeBtn.on('click', function() {
      $('.collection_offer_popup').css('display', 'none');
      $('body').removeClass('collection_offer_popup_active');
    });
  }
});
/* COLLECTION OFFER POPUP -- END */


$(document).ready(function(){
  if($('.mobileWrapper .mainChild').length!=0){
    jQuery('.mainChild').each(function(){
      if(!jQuery(this).find('a').hasClass('hasChild')){
        jQuery(this).find('a').addClass('hasChild');
      }
    });
  }
  $('.tab-link').click( function() {

    var tabID = $(this).attr('data-tab');

    $(this).addClass('active').siblings().removeClass('active');

    $('#tab-'+tabID).addClass('active').siblings().removeClass('active');
  });

  $('.mobileWrapper .mainChild > a').click(function(){

    //console.log('menu==>','open');
    if($(this).hasClass('hasChild')){
      $(this).toggleClass('open');
    }

    // Add class to the body element
    $('body').addClass('highlight-body');

    if($(this).hasClass('slider__found')){
      jQuery('.snproduct_grid').slick({
          dots: false,
          infinite: false,
          slidesToShow: 2.2,
          slidesToScroll: 1,
          variableWidth: true,
          autoplay: false,
          autoplaySpeed: 4000,
      });
    }

    // Add class to the 4th parent div
    $(this).closest('div').parent().parent().parent().addClass('highlight-parent');
  });

  $('.grandChild-drawer-close').click(function() {
    // Remove class from the body element
    $('body').removeClass('highlight-body');
    $('.mobileWrapper .mainChild > a').removeClass('open');

    // Remove class from the 4th parent div
    $('.grandchild-back-cta').closest('div').parent().parent().parent().parent().parent().parent().parent().removeClass('highlight-parent');

    $('.mobile_nav').trigger('click');
  });

  $(document).on("click",".grandchild-back-cta",function(e){
    // Remove class from the body element
    $('body').removeClass('highlight-body');
    $('.mobileWrapper .mainChild > a').removeClass('open');

    // Remove class from the 4th parent div
    $('.grandchild-back-cta').closest('div').parent().parent().parent().parent().parent().parent().parent().removeClass('highlight-parent');
    e.preventDefault();
    e.stopPropagation();
    return false;
  });

  $('.verified-slide').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1.1,
    slidesToScroll: 1
  });

});



$(document).ready(function() {
    getHeaderHeight();
});
function getHeaderHeight(){
  var classHeaderHeight = jQuery('#header').height();
  document.documentElement.style.setProperty('--header-height', classHeaderHeight+ 'px');
}

$(window).on('resize', function () {
    getHeaderHeight();
});


$(document).ready(function() {
    getcartHeight();
});
function getcartHeight(){
  var classcartHeight = jQuery(window).height();
  document.documentElement.style.setProperty('--viewport-height', classcartHeight+ 'px');
}
$(window).on('resize', function () {
    getcartHeight();
})

var headerHeight = $("#header").height();
var aboveColHeight = $('.shopify-section.collection-banner--main').height();
if (typeof aboveColHeight === "undefined") {
  aboveColHeight = 0;
  var aboveColHeight = $('.collection-header--vv').height();
}
else if(isNaN(aboveColHeight)) {
  aboveColHeight = 0
}
var colFoldHeight = $('.collection-fold-v3').outerHeight() + 19;
if (typeof colFoldHeight === "undefined") {
  colFoldHeight = 0;
}
else if(isNaN(colFoldHeight)) {
  colFoldHeight = 0
}
var buttonHeight = Math.round(aboveColHeight) + Math.round(colFoldHeight);
$(window).scroll(function () {
  var topHeight = $(window).scrollTop();
  var bcfHeader = $(".bfcm-product-exclusive-offer").height() + 24;
  //var bcfHeader = $("#header").height();
  if (typeof bcfHeader === "undefined") {
    bcfHeader = 0
  }
  else if(isNaN(bcfHeader)) {
    bcfHeader = 0
  }

  if (topHeight > buttonHeight) {
    $("body").addClass("sticky-button");
    $(".custom-sort-filter").css('top',(Math.round(headerHeight) + Math.round(bcfHeader)));
    //$(".custom-sort-filter").css('top',(Math.round(headerHeight)));
  } else {
    $("body").removeClass("sticky-button");
    $(".custom-sort-filter").css('top',0);
  }
});

//cart drawer footer checkout button hide show when shipping protection start
// TEMP: toggle logic disabled - it hid the Route widget and broke checkout.
// Route's own widget handles the checkout CTA while the toggle is out of action.
/*
jQuery(document).ready(function(){
  function setDisplayImportant($el, value) {
    $el.each(function(){
      this.style.setProperty('display', value, 'important');
    });
  }

  // function toggleCartProtection() {
  //   var $checkbox = jQuery(".cart_protection_switch #protection_switch");

  //   if ($checkbox.length === 0) return;

  //   // Re-query elements each time in case they loaded late
  //   var $routeWidget = jQuery('.cart-footer__cta [data-route-widget]');
  //   var $actionButton = jQuery('.cart-footer__cta .action_button.checkout_btn_link');

  //   // if ($checkbox.is(":checked")) {
  //   //   setDisplayImportant($routeWidget, 'block');
  //   //   setDisplayImportant($actionButton, 'none');
  //   // } else {
  //   //   setDisplayImportant($routeWidget, 'none');
  //   //   setDisplayImportant($actionButton, 'block');
  //   // }
  //   if ($checkbox.is(":checked")) {
  //     setDisplayImportant($routeWidget, 'none');
  //     setDisplayImportant($actionButton, 'block');
  //   } else {
  //     setDisplayImportant($routeWidget, 'block');
  //     setDisplayImportant($actionButton, 'none');
  //   }
  //   if($routeWidget!=null){

  //     var priceInterId = setInterval(function(){
  //       if(jQuery('.cart-footer__cta').find('.route-premium-text-stacked').length>0){
  //         if(jQuery('.cart-footer').find('.cart_protection_price').length>0){
  //           var shippingProtectionPrice = jQuery('.cart-footer__cta').find('.route-premium-text-stacked').text();
  //           if(shippingProtectionPrice!=null && shippingProtectionPrice!=undefined){
  //             shippingProtectionPrice = parseFloat(shippingProtectionPrice.replace(/[^0-9.]/g, ''));
  //             if (!isNaN(shippingProtectionPrice) && shippingProtectionPrice !== "") {
  //               shippingProtectionPrice = (shippingProtectionPrice*100);
  //               shippingProtectionPrice = window.Shopify.formatMoney(shippingProtectionPrice, $('body').data('money-format'));
  //               jQuery('.cart-footer').find('.cart_protection_price').text('+ '+shippingProtectionPrice);
  //             }
  //             //clearInterval(priceInterId);
  //           }
  //         }
  //       }
  //     },100);
  //   }
  // }
  //setTimeout(toggleCartProtection, 500);

  let routeWidgetHtml = setInterval(toggleCartProtection, 500);
  function toggleCartProtection() {
    var $checkbox = jQuery(".cart_protection_switch #protection_switch");

    if ($checkbox.length === 0) return;

    // Re-query elements each time in case they loaded late
    var $routeWidget = jQuery('.cart-footer__cta [data-route-widget]');
    var $actionButton = jQuery('.cart-footer__cta .action_button.checkout_btn_link');

    if ($checkbox.is(":checked")) {
      setDisplayImportant($routeWidget, 'none');
      setDisplayImportant($actionButton, 'flex');
    } else {
      setDisplayImportant($routeWidget, 'block');
      setDisplayImportant($actionButton, 'none');
    }
    if($routeWidget!=null){

      var priceInterId = setInterval(function(){
        if(jQuery('.cart-footer__cta').find('.route-premium-text-stacked').length>0){
          if(jQuery('.cart-footer').find('.cart_protection_price').length>0){
            var shippingProtectionPrice = jQuery('.cart-footer__cta').find('.route-premium-text-stacked').text();
            if(shippingProtectionPrice!=null && shippingProtectionPrice!=undefined){
              shippingProtectionPrice = parseFloat(shippingProtectionPrice.replace(/[^0-9.]/g, ''));
              if (!isNaN(shippingProtectionPrice) && shippingProtectionPrice !== "") {
                shippingProtectionPrice = (shippingProtectionPrice*100);
                shippingProtectionPrice = window.Shopify.formatMoney(shippingProtectionPrice, $('body').data('money-format'));
                jQuery('.cart-footer').find('.cart_protection_price').text('+ '+shippingProtectionPrice);
              }
              //clearInterval(priceInterId);
              clearInterval(routeWidgetHtml);
            }
          }
        }
      },100);
    }
  }

  // Run on change
  jQuery(document).on("change", ".cart_protection_switch #protection_switch", function(){
    var $routeWidget = jQuery('.cart-footer__cta [data-route-widget]');
    var $actionButton = jQuery('.cart-footer__cta .action_button.checkout_btn_link');
    var $actionWihtoutButton = jQuery('.cart-footer__cta .routre_without_btn_link');
    if(jQuery(this).is(":checked")) {
      setDisplayImportant($routeWidget, 'none');
      setDisplayImportant($actionButton, 'flex');
      setDisplayImportant($actionWihtoutButton, 'none');
    } else {
      setDisplayImportant($routeWidget, 'none');
      setDisplayImportant($actionButton, 'none');
      setDisplayImportant($actionWihtoutButton, 'flex');
    }
  });
});
jQuery(document).on("click", ".routre_without_btn_link", function(){
  console.log("innnnnnnn");
  var $routeWidget = jQuery('.cart-footer__cta [data-route-widget]');
  $routeWidget.find('.route-continue-without-coverage-link').trigger('click');
});
*/

// new js function
jQuery(document).ready(function(){
  function setDisplayImportant($el, value) {
    $el.each(function(){
      this.style.setProperty('display', value, 'important');
    });
  }

  // cart protection change + checkout: Route's script sometimes wraps our existing buttons in its own
  // unclassed wrapper divs (with display:none) when it re-renders its widget nearby, which traps our
  // button in a hidden ancestor no matter what display we set on the button itself. Clearing the
  // wrapper's display back out also risked exposing Route's own hidden content sharing that same
  // wrapper, so instead we re-parent the button to be a direct child of .cart-footer__cta every time -
  // that guarantees it's never nested inside anything Route controls. Inserted right before the
  // "Continue Shopping" button (its original position) rather than appended, so it stays above it
  // instead of dropping to the very end of the footer.
  function reparentToCartFooterCta($el) {
    $el.each(function () {
      var cartFooterCta = this.closest('.cart-footer__cta');
      if (!cartFooterCta || this.parentElement === cartFooterCta) return;
      var continueShoppingBtn = cartFooterCta.querySelector('.continue_shopping_button');
      if (continueShoppingBtn) {
        cartFooterCta.insertBefore(this, continueShoppingBtn);
      } else {
        cartFooterCta.appendChild(this);
      }
    });
  }

  // cart protection change + checkout: Route generically rewrites the *inner* HTML of any
  // .action_button.add_to_cart it finds on the page with its own markup (span.route-button-text +
  // span.route-premium showing the protection price), since our new button shares those base classes
  // with the original checkout button Route was designed to target. Detect that and rebuild our own
  // lock-icon + label content whenever it happens.
  var checkoutLockIconSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3334 6V4.66667C11.3334 2.8 9.86669 1.33333 8.00002 1.33333C6.13335 1.33333 4.66669 2.8 4.66669 4.66667V6C3.53335 6 2.66669 6.86666 2.66669 8V12.6667C2.66669 13.8 3.53335 14.6667 4.66669 14.6667H11.3334C12.4667 14.6667 13.3334 13.8 13.3334 12.6667V8C13.3334 6.86666 12.4667 6 11.3334 6ZM6.00002 4.66667C6.00002 3.53333 6.86669 2.66667 8.00002 2.66667C9.13335 2.66667 10 3.53333 10 4.66667V6H6.00002V4.66667Z" fill="white"/></svg>';
  function restoreWithoutCoverageButtonContent($el) {
    $el.each(function () {
      if (this.querySelector('.route-button-text, .route-premium')) {
        var label = this.getAttribute('data-checkout-label') || 'Checkout';
        this.innerHTML = '<span class="checkout_lock_icon">' + checkoutLockIconSVG + '</span> ' + label;
      }
    });
  }

  // cart protection change + checkout: single place that applies the correct checkout button state.
  // Always hides the Route widget, and shows either our own checkout button (protection ON) or the
  // "continue without coverage" button (protection OFF).
  // NOTE: the theme clones the cart footer (e.g. for mobile), so there can be multiple
  // #protection_switch checkboxes in the DOM at once with duplicate ids. jQuery's .is(":checked")
  // returns true if ANY element in the set is checked, so we read .first() as the single source of
  // truth instead - the change handler below keeps every duplicate checkbox in sync with it.
  function applyCheckoutButtonState() {
    var $checkbox = jQuery(".cart_protection_switch #protection_switch");
    var $routeWidget = jQuery('.cart-footer__cta [data-route-widget]');
    var $actionButton = jQuery('.cart-footer__cta .checkout_with_protection');
    var $withoutCoverageButton = jQuery('.cart-footer__cta .checkout_without_protection');
    var $defaultCheckoutButton = jQuery('.cart-footer__cta .action_button.checkout_btn_link');
    var $protectionBlock = jQuery('.cart_protection_block');

    reparentToCartFooterCta($actionButton);
    reparentToCartFooterCta($withoutCoverageButton);
    restoreWithoutCoverageButtonContent($withoutCoverageButton);

    setDisplayImportant($routeWidget, 'none');

    // cart protection change + checkout: checkout_with_protection only works once Route has actually
    // cloned its own checkout button (data-route-cloned-button) - that's what its click handler forwards
    // to. Until that's in the DOM, hide the protection toggle + that button and fall back to the plain
    // default checkout button so checkout still works while Route is still loading.
    var routeReady = jQuery('.cart-footer__cta [data-route-cloned-button="true"]').length > 0;

    if (!routeReady) {
      setDisplayImportant($protectionBlock, 'none');
      setDisplayImportant($actionButton, 'none');
      setDisplayImportant($withoutCoverageButton, 'none');
      setDisplayImportant($defaultCheckoutButton, 'flex');
      return;
    }

    setDisplayImportant($protectionBlock, 'flex');
    setDisplayImportant($defaultCheckoutButton, 'none');
    if ($checkbox.length && !$checkbox.first().is(":checked")) {
      setDisplayImportant($actionButton, 'none');
      setDisplayImportant($withoutCoverageButton, 'flex');
    } else {
      setDisplayImportant($withoutCoverageButton, 'none');
      setDisplayImportant($actionButton, 'flex');
    }
  }

  function toggleCartProtection() {
    var $checkbox = jQuery(".cart_protection_switch #protection_switch");

    if ($checkbox.length === 0) return;

    // Re-query elements each time in case they loaded late
    var $routeWidget = jQuery('.cart-footer__cta [data-route-widget]');

    // cart protection change + checkout: always hide the Route widget button and show our own checkout button
    // (previously this toggled based on the protection checkbox state, kept below for reference)
    // if ($checkbox.is(":checked")) {
    //   setDisplayImportant($routeWidget, 'block');
    //   setDisplayImportant($actionButton, 'none');
    // } else {
    //   setDisplayImportant($routeWidget, 'none');
    //   setDisplayImportant($actionButton, 'block');
    // }
    /*
    applyCheckoutButtonState();
    if($routeWidget!=null){
      var priceInterId = setInterval(function(){
        if(jQuery('.cart-footer__cta').find('.route-premium-text-stacked').length>0){
          if(jQuery('.cart-footer').find('.cart_protection_price').length>0){
            var shippingProtectionPrice = jQuery('.cart-footer__cta').find('.route-premium-text-stacked').text();
            if(shippingProtectionPrice!=null && shippingProtectionPrice!=undefined){
              shippingProtectionPrice = parseFloat(shippingProtectionPrice.replace(/[^0-9.]/g, ''));
              if (!isNaN(shippingProtectionPrice) && shippingProtectionPrice !== "") {
                shippingProtectionPrice = (shippingProtectionPrice*100);
                shippingProtectionPrice = window.Shopify.formatMoney(shippingProtectionPrice, $('body').data('money-format'));
                jQuery('.cart-footer').find('.cart_protection_price').text('+ '+shippingProtectionPrice);
              }
              //clearInterval(priceInterId);
            }
          }
        }
      },100);
    }
    */
    applyCheckoutButtonState();
    if($routeWidget!=null){
      // cart protection change + checkout: Route injects/re-renders .route-premium-text-stacked
      // asynchronously (same reason the checkout button state above needs its own observer), so
      // watch for it instead of polling on an interval.
      function syncProtectionPrice(){
        if(jQuery('.cart-footer__cta').find('.route-premium-text-stacked').length>0){
          if(jQuery('.cart-footer').find('.cart_protection_price').length>0){
            var shippingProtectionPrice = jQuery('.cart-footer__cta').find('.route-premium-text-stacked').text();
            if(shippingProtectionPrice!=null && shippingProtectionPrice!=undefined){
              shippingProtectionPrice = parseFloat(shippingProtectionPrice.replace(/[^0-9.]/g, ''));
              if (!isNaN(shippingProtectionPrice) && shippingProtectionPrice !== "") {
                shippingProtectionPrice = (shippingProtectionPrice*100);
                shippingProtectionPrice = window.Shopify.formatMoney(shippingProtectionPrice, $('body').data('money-format'));
                jQuery('.cart-footer').find('.cart_protection_price').text('+ '+shippingProtectionPrice);
              }
            }
          }
        }
      }
      var protectionPriceContainer = document.querySelector('.cart-footer__cta') || document.body;
      var protectionPriceObserver = new MutationObserver(syncProtectionPrice);
      protectionPriceObserver.observe(protectionPriceContainer, { subtree: true, childList: true, characterData: true });
      syncProtectionPrice();
    }

  }
  setTimeout(toggleCartProtection, 500);

  // cart protection change + checkout: this theme renders multiple copies of the cart footer
  // (mobile clone, sticky/fixed footer variant, etc.), and Route re-renders its own widget
  // asynchronously and unpredictably within them - the same reason the Route price sync above
  // uses a never-cleared setInterval instead of a one-time call. Do the same here so any button
  // copy that our event-driven calls miss still gets corrected within a fraction of a second.
  var checkoutButtonStateInterval = setInterval(applyCheckoutButtonState, 300);

  // cart protection change + checkout: Route re-injects [data-route-widget] fresh every time the
  // cart drawer opens/re-renders (e.g. .mini_cart click in sections.js.liquid), so the one-time
  // toggleCartProtection() call above misses it. Watch for it being (re)added anywhere and re-hide it.
  var routeWidgetObserver = new MutationObserver(function (mutations) {
    var routeWidgetSeen = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if ((n.matches && n.matches('[data-route-widget]')) || (n.querySelector && n.querySelector('[data-route-widget]'))) {
          routeWidgetSeen = true;
        }
      });
    });
    if (routeWidgetSeen) {
      applyCheckoutButtonState();
    }
  });
  routeWidgetObserver.observe(document.body, { subtree: true, childList: true });

  // Run on change
  jQuery(document).on("change", ".cart_protection_switch #protection_switch", function(){
    // cart protection change + checkout: always hide the Route widget button and show either our own
    // checkout button (protection ON) or the "continue without coverage" button (protection OFF)
    // (previously this toggled based on the protection checkbox state, kept below for reference)
    // if(jQuery(this).is(":checked")) {
    //   setDisplayImportant($routeWidget, 'block');
    //   setDisplayImportant($actionButton, 'none');
    // } else {
    //   setDisplayImportant($routeWidget, 'none');
    //   setDisplayImportant($actionButton, 'flex');
    // }
    // cart protection change + checkout: the theme has duplicate #protection_switch checkboxes
    // (one per cloned cart footer), so sync every one of them to whichever the customer actually
    // toggled before reading the state, otherwise a stale duplicate keeps the old state "checked"
    var isChecked = jQuery(this).is(":checked");
    jQuery(".cart_protection_switch #protection_switch").prop("checked", isChecked);
    applyCheckoutButtonState();
  });

  // cart protection change + checkout: stop re-applying button state once the customer is actually
  // heading to checkout, so our polling doesn't keep fighting the page (and flicker the buttons)
  // during the transition.
  function stopCheckoutButtonPolling() {
    clearInterval(checkoutButtonStateInterval);
    routeWidgetObserver.disconnect();
  }
  jQuery(document).on('click', '.checkout_btn_link', function () {
    stopCheckoutButtonPolling();
  });


  // new checkout_with_protection button with trigger
  jQuery(document).on('click', '.checkout_with_protection', function (e) {
    e.preventDefault();
    stopCheckoutButtonPolling();
    var clickedBtn = this;
    var keepVisibleInterval = setInterval(function () {
      clickedBtn.style.setProperty('display', 'flex', 'important');
    }, 50);
    window.addEventListener('pagehide', function () {
      clearInterval(keepVisibleInterval);
    });

    var routeLink = document.querySelector('.cart-footer__cta [data-route-cloned-button="true"]');
    if (routeLink) {
      routeLink.click();
    }
  });

  // cart protection change + checkout: clicking our styled "continue without coverage" button forwards
  // a real click to Route's hidden data-checkout-without-coverage-link, so Route's own handler still
  // runs (removing the protection product) while the customer sees our button design instead of Route's
  jQuery(document).on('click', '.checkout_without_protection', function (e) {
    e.preventDefault();
    stopCheckoutButtonPolling();
    var clickedBtn = this;
    var keepVisibleInterval = setInterval(function () {
      clickedBtn.style.setProperty('display', 'flex', 'important');
    }, 50);
    window.addEventListener('pagehide', function () {
      clearInterval(keepVisibleInterval);
    });

    var routeLink = document.querySelector('.cart-footer__cta [data-checkout-without-coverage-link="true"]');
    if (routeLink) {
      routeLink.click();
    }
  });
});
//cart drawer footer checkout button hide show when shipping protection end